import React, { useState, useEffect, createContext, useContext, useRef } from 'react';
import { createTheme, darken, lighten, createGenerateClassName, StylesProvider, ThemeProvider, makeStyles as makeStyles$1, createStyles, withStyles } from '@material-ui/core/styles';
import { useTheme, makeStyles, DialogContent, DialogContentText, Typography, TextField, DialogActions, Button, ButtonBase, Box, Link, Dialog, CircularProgress, DialogTitle, InputAdornment, Select, Divider, Snackbar, ListItem } from '@material-ui/core';
import Cookies from 'universal-cookie';
import fetch$1 from 'isomorphic-unfetch';
import ChevronRight from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import Error$1 from '@material-ui/icons/Error';
import { useCookies } from 'react-cookie';
import { Alert } from '@material-ui/lab';
import CheckCircle from '@material-ui/icons/CheckCircle';

var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["Default"] = "#fff";
    BackgroundColor["Paper"] = "#fff";
    BackgroundColor["Dark"] = "rgba(0, 0, 0, 0.8)";
})(BackgroundColor || (BackgroundColor = {}));
var CommonColor;
(function (CommonColor) {
    CommonColor["Black"] = "rgba(0, 0, 0, 1)";
    CommonColor["White"] = "#fff";
})(CommonColor || (CommonColor = {}));
var DividerColor;
(function (DividerColor) {
    DividerColor["Dark"] = "rgba(255, 255, 255, 0.3)";
    DividerColor["Light"] = "rgba(0, 0, 0, 0.12)";
})(DividerColor || (DividerColor = {}));
var ErrorColor;
(function (ErrorColor) {
    ErrorColor["ContrastText"] = "#fff";
    ErrorColor["Dark"] = "#d32f2f";
    ErrorColor["Light"] = "#e57373";
    ErrorColor["Main"] = "rgba(255, 70, 70, 1)";
})(ErrorColor || (ErrorColor = {}));
var FontFamily;
(function (FontFamily) {
    FontFamily["IbmPlexMono"] = "IBM Plex Mono";
    FontFamily["IbmPlexSans"] = "IBM Plex Sans";
    FontFamily["IbmPlexSerif"] = "IBM Plex Serif";
    FontFamily["Oswald"] = "Oswald";
    FontFamily["TitilliumWeb"] = "Titillium Web";
    FontFamily["HelveticaNeue"] = "Helvetica Neue";
    FontFamily["Arial"] = "Arial";
    FontFamily["SansSerif"] = "sans-serif";
    FontFamily["Serif"] = "serif";
    FontFamily["Roboto"] = "Roboto";
    FontFamily["Helvetica"] = "Helvetic";
    FontFamily["FreeSans"] = "FreeSans";
})(FontFamily || (FontFamily = {}));
var FontSize;
(function (FontSize) {
    FontSize[FontSize["H1"] = 46] = "H1";
    FontSize[FontSize["H2"] = 36] = "H2";
    FontSize[FontSize["H3"] = 22] = "H3";
    FontSize[FontSize["H4"] = 20] = "H4";
    FontSize[FontSize["H5"] = 18] = "H5";
    FontSize[FontSize["H6"] = 16] = "H6";
    FontSize[FontSize["Subtitle1"] = 20] = "Subtitle1";
    FontSize[FontSize["Subtitle2"] = 18] = "Subtitle2";
    FontSize[FontSize["Body1"] = 16] = "Body1";
    FontSize[FontSize["Body2"] = 14] = "Body2";
    FontSize[FontSize["Paragraph"] = 16] = "Paragraph";
    FontSize[FontSize["ParagraphLarge"] = 18] = "ParagraphLarge";
    FontSize[FontSize["ParagraphXLarge"] = 22] = "ParagraphXLarge";
})(FontSize || (FontSize = {}));
var MobileFontSize;
(function (MobileFontSize) {
    MobileFontSize[MobileFontSize["H1"] = 40] = "H1";
    MobileFontSize[MobileFontSize["H2"] = 28] = "H2";
})(MobileFontSize || (MobileFontSize = {}));
var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Normal"] = 400] = "Normal";
    FontWeight[FontWeight["Medium"] = 500] = "Medium";
    FontWeight["Bold"] = "bold";
})(FontWeight || (FontWeight = {}));
var LineHeight;
(function (LineHeight) {
    LineHeight[LineHeight["H1"] = 64] = "H1";
    LineHeight[LineHeight["H2"] = 40] = "H2";
    LineHeight[LineHeight["H3"] = 26] = "H3";
    LineHeight[LineHeight["H4"] = 24] = "H4";
    LineHeight[LineHeight["H5"] = 24] = "H5";
    LineHeight[LineHeight["H6"] = 21] = "H6";
    LineHeight[LineHeight["Subtitle1"] = 34] = "Subtitle1";
    LineHeight[LineHeight["Subtitle2"] = 32] = "Subtitle2";
    LineHeight[LineHeight["Body1"] = 21] = "Body1";
    LineHeight[LineHeight["Body2"] = 19] = "Body2";
    LineHeight[LineHeight["Paragraph"] = 28] = "Paragraph";
    LineHeight[LineHeight["ParagraphLarge"] = 32] = "ParagraphLarge";
    LineHeight[LineHeight["ParagraphXLarge"] = 36] = "ParagraphXLarge";
})(LineHeight || (LineHeight = {}));
var MobileLineHeight;
(function (MobileLineHeight) {
    MobileLineHeight[MobileLineHeight["H1"] = 50] = "H1";
    MobileLineHeight[MobileLineHeight["H2"] = 32] = "H2";
})(MobileLineHeight || (MobileLineHeight = {}));
var PaletteType;
(function (PaletteType) {
    PaletteType["Dark"] = "dark";
    PaletteType["Light"] = "light";
})(PaletteType || (PaletteType = {}));
var PrimaryColor;
(function (PrimaryColor) {
    PrimaryColor["ContrastText"] = "#fff";
    PrimaryColor["Dark"] = "#303f9f";
    PrimaryColor["Light"] = "#7986cb";
    PrimaryColor["Main"] = "rgba(0, 69, 255, 1)";
})(PrimaryColor || (PrimaryColor = {}));
var RelativeSize;
(function (RelativeSize) {
    RelativeSize[RelativeSize["Full"] = 0] = "Full";
    RelativeSize[RelativeSize["Large"] = 1] = "Large";
    RelativeSize[RelativeSize["Medium"] = 2] = "Medium";
    RelativeSize[RelativeSize["Small"] = 3] = "Small";
})(RelativeSize || (RelativeSize = {}));
var SecondaryColor;
(function (SecondaryColor) {
    SecondaryColor["ContrastText"] = "#fff";
    SecondaryColor["Dark"] = "#c51162";
    SecondaryColor["Light"] = "#ff4081";
    SecondaryColor["Main"] = "rgba(255, 70, 70, 1)";
})(SecondaryColor || (SecondaryColor = {}));
var TextColor;
(function (TextColor) {
    TextColor["Disabled"] = "rgba(0, 0, 0, 0.27)";
    TextColor["Hint"] = "rgba(0, 0, 0, 0.38)";
    TextColor["Primary"] = "rgba(0, 0, 0, 1)";
    TextColor["Secondary"] = "rgba(0, 0, 0, 0.72)";
})(TextColor || (TextColor = {}));
var TextColorDark;
(function (TextColorDark) {
    TextColorDark["Disabled"] = "rgba(255, 255, 255, 0.5)";
    TextColorDark["Hint"] = "rgba(255, 255, 255, 0.4)";
    TextColorDark["Primary"] = "rgba(255, 255, 255, 1)";
    TextColorDark["Secondary"] = "rgba(255, 255, 255, 0.65)";
})(TextColorDark || (TextColorDark = {}));
const InteractiveColorLight = '#002C9E';
const InteractiveColorDark = '#68bdff';
var QuoteColor;
(function (QuoteColor) {
    QuoteColor["Default"] = "#F5F8FD";
    QuoteColor["Active"] = "#000";
    QuoteColor["Link"] = "rgba(0, 69, 255, 1)";
    QuoteColor["Grey"] = "rgba(255, 255, 255, 0.65)";
})(QuoteColor || (QuoteColor = {}));
const defaultFontFamily = [
    FontFamily.IbmPlexSans,
    FontFamily.HelveticaNeue,
    FontFamily.Arial,
    FontFamily.SansSerif
].join();
const serifFontFamily = [FontFamily.IbmPlexSerif, FontFamily.Serif].join();
const legacyFontFamily = [
    FontFamily.Roboto,
    FontFamily.HelveticaNeue,
    FontFamily.Helvetica,
    FontFamily.FreeSans,
    FontFamily.Arial,
    FontFamily.SansSerif
].join();
const keyMenuFont = [
    FontFamily.IbmPlexMono,
    FontFamily.HelveticaNeue,
    FontFamily.Arial,
    FontFamily.SansSerif
].join();
function makeDarkPalette(paletteType, primaryColor, secondaryColor) {
    return {
        type: paletteType,
        common: { black: CommonColor.Black, white: CommonColor.White },
        background: {
            paper: BackgroundColor.Dark,
            default: BackgroundColor.Dark
        },
        divider: DividerColor.Dark,
        primary: {
            main: primaryColor || PrimaryColor.Main,
            background: darken(primaryColor || PrimaryColor.Main, 0.95)
        },
        secondary: {
            main: secondaryColor || SecondaryColor.Main
        },
        error: {
            light: ErrorColor.Light,
            main: ErrorColor.Main,
            dark: ErrorColor.Dark,
            contrastText: ErrorColor.ContrastText
        },
        text: {
            primary: TextColorDark.Primary,
            secondary: TextColorDark.Secondary,
            disabled: TextColorDark.Disabled,
            hint: TextColorDark.Hint
        },
        interactive: {
            main: InteractiveColorDark,
            hover: lighten(InteractiveColorDark, 0.2)
        }
    };
}
function makeDimensions() {
    return {
        mobileWidth: 600,
        maxDesktopWidth: 1200,
        streamWidth: 788,
        streamAsideWidth: 377,
        maxReadableLength: 582,
        topNavHeight: 88,
        tabletTopNavHeight: 70,
        mobileTopNavHeight: 74,
        universalTopNavHeight: 64,
        universalMobileTopNavHeight: 56,
        drawerWidthMin: 350,
        drawerWidthMax: 409,
        suggestionMinWidth: 200
    };
}
function makeGutter(baseTheme) {
    return {
        xSmall: baseTheme.spacing(0.5),
        small: baseTheme.spacing(1),
        medium: baseTheme.spacing(3) / 2,
        normal: baseTheme.spacing(2),
        large: baseTheme.spacing(4),
        xLarge: baseTheme.spacing(9) / 2
    };
}
function makeIcon(baseTheme) {
    return {
        large: baseTheme.typography.pxToRem(24),
        normal: baseTheme.typography.pxToRem(20),
        small: baseTheme.typography.pxToRem(16)
    };
}
function makeLightPalette(paletteType, primaryColor, secondaryColor) {
    return {
        type: paletteType,
        common: { black: CommonColor.Black, white: CommonColor.White },
        background: {
            paper: BackgroundColor.Paper,
            default: BackgroundColor.Default
        },
        divider: DividerColor.Light,
        primary: {
            main: primaryColor || PrimaryColor.Main,
            background: lighten(primaryColor || PrimaryColor.Main, 0.95)
        },
        secondary: {
            main: secondaryColor || SecondaryColor.Main
        },
        error: {
            light: ErrorColor.Light,
            main: ErrorColor.Main,
            dark: ErrorColor.Dark,
            contrastText: ErrorColor.ContrastText
        },
        text: {
            primary: TextColor.Primary,
            secondary: TextColor.Secondary,
            disabled: TextColor.Disabled,
            hint: TextColor.Hint
        },
        interactive: {
            main: InteractiveColorLight,
            hover: lighten(InteractiveColorLight, 0.2)
        }
    };
}
function makePalette(paletteType, primaryColor, secondaryColor) {
    return paletteType === PaletteType.Dark
        ? makeDarkPalette(paletteType, primaryColor, secondaryColor)
        : makeLightPalette(paletteType, primaryColor, secondaryColor);
}
function makeQuote() {
    return {
        background: QuoteColor.Default,
        active: QuoteColor.Active,
        linkColor: QuoteColor.Link,
        greyText: QuoteColor.Grey
    };
}
function makeShape() {
    return {
        borderRadius: 6,
        smallBorderRadius: 4
    };
}
function makeBreakpoints(baseTheme) {
    const breakpoints = baseTheme.breakpoints;
    breakpoints.values.xl = 1450;
    const mavenBreakpoints = Object.assign(Object.assign({}, breakpoints), { isTabletDesktopOrHD: breakpoints.up('sm'), isDesktopOrHD: breakpoints.up('lg'), isHD: breakpoints.up('xl'), isDesktop: breakpoints.only('lg'), isTablet: breakpoints.between('sm', 'md'), isMobile: breakpoints.down('xs') });
    return mavenBreakpoints;
}
function makeTypography(baseTheme) {
    const typography = Object.assign(Object.assign({}, baseTheme.typography), { textShadow: '0px 0px 5px rgba(0, 0, 0, 0.9)', titleShadow: '2px 4px 1.5vw black', fontFamily: defaultFontFamily, legacyFontFamily, whitepaperFontFamily: [FontFamily.Oswald], h1: Object.assign(Object.assign({}, baseTheme.typography.h1), { fontFamily: serifFontFamily, fontWeight: FontWeight.Bold, fontSize: baseTheme.typography.pxToRem(FontSize.H1), lineHeight: baseTheme.typography.pxToRem(LineHeight.H1), [baseTheme.breakpoints.down('sm') + ' ']: {
                fontSize: baseTheme.typography.pxToRem(MobileFontSize.H1),
                lineHeight: baseTheme.typography.pxToRem(MobileLineHeight.H1),
                margin: 0
            } }), h2: Object.assign(Object.assign({}, baseTheme.typography.h2), { fontFamily: serifFontFamily, fontWeight: FontWeight.Bold, fontSize: baseTheme.typography.pxToRem(FontSize.H2), lineHeight: baseTheme.typography.pxToRem(LineHeight.H2), [baseTheme.breakpoints.down('sm') + ' ']: {
                fontSize: baseTheme.typography.pxToRem(MobileFontSize.H2),
                lineHeight: baseTheme.typography.pxToRem(MobileLineHeight.H2)
            } }), h3: Object.assign(Object.assign({}, baseTheme.typography.h3), { fontFamily: serifFontFamily, fontWeight: FontWeight.Bold, fontSize: baseTheme.typography.pxToRem(FontSize.H3), lineHeight: baseTheme.typography.pxToRem(LineHeight.H3) }), h4: Object.assign(Object.assign({}, baseTheme.typography.h4), { fontWeight: FontWeight.Bold, fontSize: baseTheme.typography.pxToRem(FontSize.H4), lineHeight: baseTheme.typography.pxToRem(LineHeight.H4) }), h5: Object.assign(Object.assign({}, baseTheme.typography.h5), { fontWeight: FontWeight.Bold, fontSize: baseTheme.typography.pxToRem(FontSize.H5), lineHeight: baseTheme.typography.pxToRem(LineHeight.H5) }), h6: Object.assign(Object.assign({}, baseTheme.typography.h6), { fontSize: baseTheme.typography.pxToRem(FontSize.H6), lineHeight: baseTheme.typography.pxToRem(LineHeight.H6) }), subtitle1: Object.assign(Object.assign({}, baseTheme.typography.subtitle1), { fontSize: baseTheme.typography.pxToRem(FontSize.Subtitle1), lineHeight: baseTheme.typography.pxToRem(LineHeight.Subtitle1) }), subtitle2: Object.assign(Object.assign({}, baseTheme.typography.subtitle2), { fontSize: baseTheme.typography.pxToRem(FontSize.Subtitle2), lineHeight: baseTheme.typography.pxToRem(LineHeight.Subtitle2) }), body1: Object.assign(Object.assign({}, baseTheme.typography.body1), { fontFamily: defaultFontFamily, fontSize: baseTheme.typography.pxToRem(FontSize.Body1), lineHeight: baseTheme.typography.pxToRem(LineHeight.Body1) }), body2: Object.assign(Object.assign({}, baseTheme.typography.body2), { fontFamily: defaultFontFamily, fontSize: baseTheme.typography.pxToRem(FontSize.Body2), lineHeight: baseTheme.typography.pxToRem(LineHeight.Body2) }), button: Object.assign(Object.assign({}, baseTheme.typography.button), { textTransform: 'none' }), paragraph: {
            fontFamily: defaultFontFamily,
            fontSize: baseTheme.typography.pxToRem(FontSize.Paragraph),
            lineHeight: baseTheme.typography.pxToRem(LineHeight.Paragraph)
        }, paragraphLarge: {
            fontFamily: defaultFontFamily,
            fontSize: baseTheme.typography.pxToRem(FontSize.ParagraphLarge),
            lineHeight: baseTheme.typography.pxToRem(LineHeight.ParagraphLarge)
        }, paragraphXLarge: {
            fontFamily: defaultFontFamily,
            fontSize: baseTheme.typography.pxToRem(FontSize.ParagraphXLarge),
            lineHeight: baseTheme.typography.pxToRem(LineHeight.ParagraphXLarge)
        }, keyMenu: {
            fontFamily: keyMenuFont,
            fontSize: baseTheme.typography.pxToRem(FontSize.Body1),
            lineHeight: baseTheme.typography.pxToRem(LineHeight.Body2)
        }, topLinks: Object.assign({ fontFamily: defaultFontFamily, fontSize: baseTheme.typography.pxToRem(FontSize.Body1), lineHeight: baseTheme.typography.pxToRem(LineHeight.Body1) }, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.topLinksTypography), formHeading: Object.assign(Object.assign({}, baseTheme.typography.h6), { textTransform: 'uppercase' }) });
    return typography;
}
function makeBaseTheme(paletteType, primaryColor, secondaryColor) {
    return createTheme({
        palette: makePalette(paletteType, primaryColor, secondaryColor),
        typography: { fontFamily: defaultFontFamily },
        shape: makeShape(),
        overrides: {
            MuiDrawer: {
                paper: {
                    backgroundColor: BackgroundColor.Dark,
                    backgroundBlendMode: 'multiply',
                    backdropFilter: 'blur(4px)',
                    color: CommonColor.White,
                    fontSize: FontSize.Subtitle1
                }
            },
            MuiTooltip: {
                tooltip: {
                    fontSize: FontSize.Body2,
                    backgroundColor: BackgroundColor.Dark,
                    fontWeight: FontWeight.Normal
                }
            },
            MuiButton: {
                outlined: {
                    textTransform: 'uppercase',
                    fontWeight: FontWeight.Bold
                },
                contained: {
                    backgroundColor: TextColor.Primary,
                    color: PrimaryColor.ContrastText,
                    textTransform: 'uppercase',
                    fontWeight: FontWeight.Bold,
                    '& svg path': {
                        fill: PrimaryColor.ContrastText
                    },
                    '&:hover': {
                        backgroundColor: TextColor.Secondary,
                        color: PrimaryColor.ContrastText,
                        '& svg path': {
                            fill: PrimaryColor.ContrastText
                        }
                    }
                }
            }
        }
    });
}
function makeMavenTheme(theme) {
    return Object.assign(Object.assign({}, theme), { palette: theme.palette, breakpoints: makeBreakpoints(theme), typography: makeTypography(theme), gutter: makeGutter(theme), icon: makeIcon(theme), dimensions: makeDimensions(), quote: makeQuote(), zIndex: Object.assign(Object.assign({}, theme.zIndex), { modal: 5000000 + 1300 }) });
}
function makeSodoTheme(paletteType, primaryColor, secondaryColor) {
    const baseTheme = makeBaseTheme(paletteType, primaryColor, secondaryColor);
    return makeMavenTheme(baseTheme);
}
const sodoTheme = (primaryColor, secondaryColor) => makeSodoTheme(PaletteType.Light, primaryColor, secondaryColor);
const sodoDarkTheme = (primaryColor, secondaryColor) => makeSodoTheme(PaletteType.Dark, primaryColor, secondaryColor);

const SodoThemeProvider = ({ primaryColor, secondaryColor, type = PaletteType.Light, classNameProdPrefix, children }) => {
    const generateClassName = createGenerateClassName({
        productionPrefix: classNameProdPrefix
    });
    const theme = useTheme();
    const primary = primaryColor || (theme ? theme.palette.primary.main : undefined);
    const secondary = secondaryColor || (theme ? theme.palette.secondary.main : undefined);
    return (React.createElement(StylesProvider, { generateClassName: generateClassName },
        React.createElement(ThemeProvider, { theme: type === PaletteType.Light ? sodoTheme(primary, secondary) : sodoDarkTheme(primary, secondary) }, children)));
};

const ConfigContext = React.createContext({
    authConfig: null,
    updateAuthConfig: (config) => null
});
const ConfigContextProvider = ({ children, authConfig }) => {
    const [currentAuthConfig, setCurrentAuthConfig] = useState(null);
    useEffect(() => {
        setCurrentAuthConfig(authConfig);
    }, []);
    const updateAuthConfig = (config) => {
        setCurrentAuthConfig(Object.assign(Object.assign({}, currentAuthConfig), config));
    };
    return (React.createElement(ConfigContext.Provider, { value: { authConfig: currentAuthConfig, updateAuthConfig } }, children));
};

var LoginStep;
(function (LoginStep) {
    LoginStep[LoginStep["GetEmail"] = 0] = "GetEmail";
    LoginStep[LoginStep["SendCodeEmail"] = 1] = "SendCodeEmail";
    LoginStep[LoginStep["WaitForCode"] = 2] = "WaitForCode";
    LoginStep[LoginStep["CheckCode"] = 3] = "CheckCode";
    LoginStep[LoginStep["ClassicLogin"] = 4] = "ClassicLogin";
    LoginStep[LoginStep["SendC3LoginCredentials"] = 5] = "SendC3LoginCredentials";
    LoginStep[LoginStep["SendSalishLoginCredentials"] = 6] = "SendSalishLoginCredentials";
    LoginStep[LoginStep["GetUsername"] = 7] = "GetUsername";
    LoginStep[LoginStep["SetUsername"] = 8] = "SetUsername";
    LoginStep[LoginStep["Complete"] = 9] = "Complete";
})(LoginStep || (LoginStep = {}));
var LoginUsernameCollectionBehavior;
(function (LoginUsernameCollectionBehavior) {
    LoginUsernameCollectionBehavior[LoginUsernameCollectionBehavior["None"] = 0] = "None";
    LoginUsernameCollectionBehavior[LoginUsernameCollectionBehavior["Required"] = 1] = "Required";
    LoginUsernameCollectionBehavior[LoginUsernameCollectionBehavior["Optional"] = 2] = "Optional";
})(LoginUsernameCollectionBehavior || (LoginUsernameCollectionBehavior = {}));
var LoginCodeSource;
(function (LoginCodeSource) {
    LoginCodeSource["None"] = "None";
    LoginCodeSource["Login"] = "Login";
    LoginCodeSource["JoinFree"] = "JoinFree";
    LoginCodeSource["Subscribe"] = "Subscribe";
    LoginCodeSource["StandaloneLogin"] = "StandaloneLogin";
    LoginCodeSource["CoralLogin"] = "CoralLogin";
})(LoginCodeSource || (LoginCodeSource = {}));

const UserEventCategory = {
    System: 0,
    User: 1,
    Stream: 2,
    Conversation: 3,
    Video: 4,
    Audio: 5,
    Sharing: 6,
    Advertisement: 7,
    Widget: 8,
    Navigation: 9
};
var UserEventTypeResponse;
(function (UserEventTypeResponse) {
    UserEventTypeResponse["View"] = "View";
    UserEventTypeResponse["Navigate"] = "Navigate";
    UserEventTypeResponse["UserRegistered"] = "UserRegistered";
    UserEventTypeResponse["RescoreUser"] = "RescoreUser";
    UserEventTypeResponse["Preview"] = "Preview";
    UserEventTypeResponse["EnteredText"] = "EnteredText";
    UserEventTypeResponse["ClearedText"] = "ClearedText";
    UserEventTypeResponse["SentMessage"] = "SentMessage";
    UserEventTypeResponse["ReadMore"] = "ReadMore";
    UserEventTypeResponse["ReadMessage"] = "ReadMessage";
    UserEventTypeResponse["Play"] = "Play";
    UserEventTypeResponse["PlayPercent"] = "PlayPercent";
    UserEventTypeResponse["PlaySeconds"] = "PlaySeconds";
    UserEventTypeResponse["JoinChannel"] = "JoinChannel";
    UserEventTypeResponse["NewQuickpost"] = "NewQuickpost";
    UserEventTypeResponse["NewStory"] = "NewStory";
    UserEventTypeResponse["NewVideoStory"] = "NewVideoStory";
    UserEventTypeResponse["LoadMore"] = "LoadMore";
    UserEventTypeResponse["CopyLinkStart"] = "CopyLinkStart";
    UserEventTypeResponse["FacebookShareStart"] = "FacebookShareStart";
    UserEventTypeResponse["TwitterShareStart"] = "TwitterShareStart";
    UserEventTypeResponse["PinterestShareStart"] = "PinterestShareStart";
    UserEventTypeResponse["CopyLinkComplete"] = "CopyLinkComplete";
    UserEventTypeResponse["FacebookShareComplete"] = "FacebookShareComplete";
    UserEventTypeResponse["TwitterShareComplete"] = "TwitterShareComplete";
    UserEventTypeResponse["PinterestShareComplete"] = "PinterestShareComplete";
    UserEventTypeResponse["LeaveChannel"] = "LeaveChannel";
    UserEventTypeResponse["Subscribe"] = "Subscribe";
    UserEventTypeResponse["ChangeSetting"] = "ChangeSetting";
    UserEventTypeResponse["UploadMedia"] = "UploadMedia";
    UserEventTypeResponse["AdCall"] = "AdCall";
    UserEventTypeResponse["AdCallSuccess"] = "AdCallSuccess";
    UserEventTypeResponse["AdCallFailure"] = "AdCallFailure";
    UserEventTypeResponse["Search"] = "Search";
    UserEventTypeResponse["UploadFailure"] = "UploadFailure";
    UserEventTypeResponse["UploadComplete"] = "UploadComplete";
    UserEventTypeResponse["UploadProgress"] = "UploadProgress";
    UserEventTypeResponse["VideoManuallyTranscoded"] = "VideoManuallyTranscoded";
    UserEventTypeResponse["TranscodeJobBegun"] = "TranscodeJobBegun";
    UserEventTypeResponse["TranscodeJobComplete"] = "TranscodeJobComplete";
    UserEventTypeResponse["TranscodeJobError"] = "TranscodeJobError";
    UserEventTypeResponse["VideoTranscodedEnoughRenderable"] = "VideoTranscodedEnoughRenderable";
    UserEventTypeResponse["TranscodeJobCritical"] = "TranscodeJobCritical";
    UserEventTypeResponse["VideoCritical"] = "VideoCritical";
    UserEventTypeResponse["GdprShown"] = "GdprShown";
    UserEventTypeResponse["GdprAccept"] = "GdprAccept";
    UserEventTypeResponse["GdprDecline"] = "GdprDecline";
    UserEventTypeResponse["VideoDownloadRequested"] = "VideoDownloadRequested";
    UserEventTypeResponse["ShufflerNext"] = "ShufflerNext";
    UserEventTypeResponse["ShufflerPrevious"] = "ShufflerPrevious";
    UserEventTypeResponse["UpdateL1Sort"] = "UpdateL1Sort";
    UserEventTypeResponse["UpdateL2Sort"] = "UpdateL2Sort";
    UserEventTypeResponse["LoginWithPassword"] = "LoginWithPassword";
    UserEventTypeResponse["LoginWithOauth"] = "LoginWithOauth";
    UserEventTypeResponse["MuidInterstitialVisitedFirst"] = "MuidInterstitialVisitedFirst";
    UserEventTypeResponse["MuidInterstitialClickContinue"] = "MuidInterstitialClickContinue";
    UserEventTypeResponse["MuidInterstitialVisitedAgain"] = "MuidInterstitialVisitedAgain";
    UserEventTypeResponse["MarkNotificationsConsumed"] = "MarkNotificationsConsumed";
    UserEventTypeResponse["WidgetLoaded"] = "WidgetLoaded";
    UserEventTypeResponse["WidgetOpened"] = "WidgetOpened";
    UserEventTypeResponse["WidgetClosed"] = "WidgetClosed";
    UserEventTypeResponse["WidgetHidden"] = "WidgetHidden";
    UserEventTypeResponse["WidgetHeightChanged"] = "WidgetHeightChanged";
    UserEventTypeResponse["LikePost"] = "LikePost";
    UserEventTypeResponse["LikeReply"] = "LikeReply";
    UserEventTypeResponse["ReportMessage"] = "ReportMessage";
    UserEventTypeResponse["StartPost"] = "StartPost";
    UserEventTypeResponse["StartReply"] = "StartReply";
})(UserEventTypeResponse || (UserEventTypeResponse = {}));
var ReactionType;
(function (ReactionType) {
    ReactionType["None"] = "None";
    ReactionType["Like"] = "Like";
    ReactionType["Laugh"] = "Laugh";
    ReactionType["Shock"] = "Shock";
})(ReactionType || (ReactionType = {}));
var ActionAuthorizationState;
(function (ActionAuthorizationState) {
    ActionAuthorizationState["Yes"] = "Yes";
    ActionAuthorizationState["No"] = "No";
    ActionAuthorizationState["Register"] = "Register";
    ActionAuthorizationState["VerifyEmail"] = "VerifyEmail";
    ActionAuthorizationState["Subscribe"] = "Subscribe";
    ActionAuthorizationState["Publisher"] = "Publisher";
    ActionAuthorizationState["Username"] = "Username";
})(ActionAuthorizationState || (ActionAuthorizationState = {}));
var AccountActionMode;
(function (AccountActionMode) {
    AccountActionMode["None"] = "None";
    AccountActionMode["Login"] = "Login";
    AccountActionMode["Register"] = "Register";
    AccountActionMode["Registered"] = "Registered";
    AccountActionMode["Username"] = "Username";
    AccountActionMode["VerifyEmail"] = "VerifyEmail";
    AccountActionMode["ForgotPassword"] = "ForgotPassword";
    AccountActionMode["ResetPassword"] = "ResetPassword";
})(AccountActionMode || (AccountActionMode = {}));
var UrlType;
(function (UrlType) {
    UrlType["Html"] = "Html";
    UrlType["Image"] = "Image";
})(UrlType || (UrlType = {}));
var Align;
(function (Align) {
    Align["Left"] = "Left";
    Align["Right"] = "Right";
    Align["Center"] = "Center";
})(Align || (Align = {}));
var ImageSize;
(function (ImageSize) {
    ImageSize["Small"] = "Small";
    ImageSize["Medium"] = "Medium";
    ImageSize["Large"] = "Large";
    ImageSize["Original"] = "Original";
})(ImageSize || (ImageSize = {}));

const logEventType = 'log-event';
const logEventHelper = ({ category, channelKey, conversationId, label, loginToken, messageId, roomKey, type, value, viewType, navigateDestination, currentLocation, typeContainerName, component }) => {
    const event = new CustomEvent(logEventType, {
        detail: {
            category,
            channelKey,
            conversationId,
            label,
            loginToken,
            messageId,
            roomKey,
            type,
            value,
            viewType,
            navigateDestination,
            currentLocation,
            typeContainerName,
            component
        }
    });
    window.dispatchEvent(event);
};

const ONE_YEAR_IN_MILLISECONDS = 31104000000;
const UserTokenCookieName$1 = 'mut';
const CoralTokenCookieName$1 = 'mct';
class UserLoginStore {
    constructor(cookieConfig) {
        this.cookieConfig = Object.assign({ rgisName: 'RGIS' }, cookieConfig);
        const hasDocument = typeof document !== 'undefined';
        let domainValue = hasDocument ? document.domain : '';
        if (domainValue && domainValue.split('.').length > 2) {
            domainValue = domainValue.substr(domainValue.indexOf('.'));
        }
        this.opts = {
            domain: domainValue,
            encode: val => {
                return val;
            },
            expires: (cookieConfig === null || cookieConfig === void 0 ? void 0 : cookieConfig.expires) || new Date(Date.now() + ONE_YEAR_IN_MILLISECONDS),
            path: '/',
            secure: (cookieConfig === null || cookieConfig === void 0 ? void 0 : cookieConfig.secure) === false ? false : true
        };
        this.cookies = new Cookies();
    }
    setRgisCookie(rgis) {
        if (this.cookieConfig.rgisName) {
            this.cookies.set(this.cookieConfig.rgisName, JSON.stringify(rgis || ''), this.opts);
        }
    }
    setUserLogin(user) {
        const { c3RGIS: rgisCookie, userToken, coralToken } = user;
        this.setRgisCookie(rgisCookie);
        if (userToken) {
            this.cookies.set(UserTokenCookieName$1, userToken, this.opts);
        }
        if (coralToken) {
            this.setCoralToken(coralToken);
        }
        logEventHelper({
            category: UserEventCategory.User,
            value: 'userLoginCompleted'
        });
    }
    setCoralToken(coralToken) {
        if (coralToken) {
            this.cookies.set(CoralTokenCookieName$1, coralToken, this.opts);
        }
    }
    getRgisCookie() {
        return this.cookies.get(this.cookieConfig.rgisName);
    }
    getUserTokenCookie() {
        return this.cookies.get(UserTokenCookieName$1);
    }
    getCoralTokenCookie() {
        return this.cookies.get(CoralTokenCookieName$1);
    }
    removeUserLogin() {
        if (this.cookieConfig.rgisName) {
            this.cookies.remove(this.cookieConfig.rgisName, this.opts);
        }
        this.cookies.remove(UserTokenCookieName$1, this.opts);
        this.cookies.remove(CoralTokenCookieName$1, this.opts);
        logEventHelper({
            category: UserEventCategory.User,
            value: 'userLogoutCompleted'
        });
        window.location.hash = window.location.hash.replace(/(#|&)?viaLogin(Complete)?/g, '');
    }
}

const setItem = (key, value) => {
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        localStorage.setItem(key, value);
        return true;
    }
    catch (err) {
        console.error(`Could not set localStorage key ${key}`, err);
        return false;
    }
};
const removeItem = (key) => {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.removeItem(key);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var canadianProvinces = [
	{
		name: "Alberta",
		abbreviation: "AB"
	},
	{
		name: "British Columbia",
		abbreviation: "BC"
	},
	{
		name: "Manitoba",
		abbreviation: "MB"
	},
	{
		name: "New Brunswick",
		abbreviation: "NB"
	},
	{
		name: "Newfoundland and Labrador",
		abbreviation: "NL"
	},
	{
		name: "Northwest Territories",
		abbreviation: "NT"
	},
	{
		name: "Nova Scotia",
		abbreviation: "NS"
	},
	{
		name: "Nunavut",
		abbreviation: "NU"
	},
	{
		name: "Ontario",
		abbreviation: "ON"
	},
	{
		name: "Prince Edward Island",
		abbreviation: "PE"
	},
	{
		name: "Quebec",
		abbreviation: "QC"
	},
	{
		name: "Saskatchewan",
		abbreviation: "SK"
	},
	{
		name: "Yukon",
		abbreviation: "YT"
	}
];

var usStates = [
	{
		name: "Alabama",
		abbreviation: "AL"
	},
	{
		name: "Alaska",
		abbreviation: "AK"
	},
	{
		name: "American Samoa",
		abbreviation: "AS"
	},
	{
		name: "Arizona",
		abbreviation: "AZ"
	},
	{
		name: "Arkansas",
		abbreviation: "AR"
	},
	{
		name: "California",
		abbreviation: "CA"
	},
	{
		name: "Colorado",
		abbreviation: "CO"
	},
	{
		name: "Connecticut",
		abbreviation: "CT"
	},
	{
		name: "Delaware",
		abbreviation: "DE"
	},
	{
		name: "District Of Columbia",
		abbreviation: "DC"
	},
	{
		name: "Federated States Of Micronesia",
		abbreviation: "FM"
	},
	{
		name: "Florida",
		abbreviation: "FL"
	},
	{
		name: "Georgia",
		abbreviation: "GA"
	},
	{
		name: "Guam",
		abbreviation: "GU"
	},
	{
		name: "Hawaii",
		abbreviation: "HI"
	},
	{
		name: "Idaho",
		abbreviation: "ID"
	},
	{
		name: "Illinois",
		abbreviation: "IL"
	},
	{
		name: "Indiana",
		abbreviation: "IN"
	},
	{
		name: "Iowa",
		abbreviation: "IA"
	},
	{
		name: "Kansas",
		abbreviation: "KS"
	},
	{
		name: "Kentucky",
		abbreviation: "KY"
	},
	{
		name: "Louisiana",
		abbreviation: "LA"
	},
	{
		name: "Maine",
		abbreviation: "ME"
	},
	{
		name: "Marshall Islands",
		abbreviation: "MH"
	},
	{
		name: "Maryland",
		abbreviation: "MD"
	},
	{
		name: "Massachusetts",
		abbreviation: "MA"
	},
	{
		name: "Michigan",
		abbreviation: "MI"
	},
	{
		name: "Minnesota",
		abbreviation: "MN"
	},
	{
		name: "Mississippi",
		abbreviation: "MS"
	},
	{
		name: "Missouri",
		abbreviation: "MO"
	},
	{
		name: "Montana",
		abbreviation: "MT"
	},
	{
		name: "Nebraska",
		abbreviation: "NE"
	},
	{
		name: "Nevada",
		abbreviation: "NV"
	},
	{
		name: "New Hampshire",
		abbreviation: "NH"
	},
	{
		name: "New Jersey",
		abbreviation: "NJ"
	},
	{
		name: "New Mexico",
		abbreviation: "NM"
	},
	{
		name: "New York",
		abbreviation: "NY"
	},
	{
		name: "North Carolina",
		abbreviation: "NC"
	},
	{
		name: "North Dakota",
		abbreviation: "ND"
	},
	{
		name: "Northern Mariana Islands",
		abbreviation: "MP"
	},
	{
		name: "Ohio",
		abbreviation: "OH"
	},
	{
		name: "Oklahoma",
		abbreviation: "OK"
	},
	{
		name: "Oregon",
		abbreviation: "OR"
	},
	{
		name: "Palau",
		abbreviation: "PW"
	},
	{
		name: "Pennsylvania",
		abbreviation: "PA"
	},
	{
		name: "Puerto Rico",
		abbreviation: "PR"
	},
	{
		name: "Rhode Island",
		abbreviation: "RI"
	},
	{
		name: "South Carolina",
		abbreviation: "SC"
	},
	{
		name: "South Dakota",
		abbreviation: "SD"
	},
	{
		name: "Tennessee",
		abbreviation: "TN"
	},
	{
		name: "Texas",
		abbreviation: "TX"
	},
	{
		name: "Utah",
		abbreviation: "UT"
	},
	{
		name: "Vermont",
		abbreviation: "VT"
	},
	{
		name: "Virgin Islands",
		abbreviation: "VI"
	},
	{
		name: "Virginia",
		abbreviation: "VA"
	},
	{
		name: "Washington",
		abbreviation: "WA"
	},
	{
		name: "West Virginia",
		abbreviation: "WV"
	},
	{
		name: "Wisconsin",
		abbreviation: "WI"
	},
	{
		name: "Wyoming",
		abbreviation: "WY"
	}
];

var ePaymentMethod;
(function (ePaymentMethod) {
    ePaymentMethod["CreditCard"] = "Credit Card";
})(ePaymentMethod || (ePaymentMethod = {}));
var eStatus;
(function (eStatus) {
    eStatus["Default"] = "";
    eStatus["Submitting"] = "isSubmitting";
    eStatus["Error"] = "error";
    eStatus["Success"] = "success";
})(eStatus || (eStatus = {}));
var ePortalTabs;
(function (ePortalTabs) {
    ePortalTabs[ePortalTabs["Profile"] = 0] = "Profile";
    ePortalTabs[ePortalTabs["Email"] = 1] = "Email";
    ePortalTabs[ePortalTabs["Subscriptions"] = 2] = "Subscriptions";
    ePortalTabs[ePortalTabs["Alerts"] = 3] = "Alerts";
    ePortalTabs[ePortalTabs["Contact"] = 4] = "Contact";
})(ePortalTabs || (ePortalTabs = {}));

var PermutiveAction;
(function (PermutiveAction) {
    PermutiveAction["NewsletterSignup"] = "successfulNewsletterSignup";
    PermutiveAction["PremiumSubSignup"] = "successfulPremiumSubSignup";
    PermutiveAction["NewsletterSignupAbandoned"] = "newsletterAbandoned";
    PermutiveAction["PremiumSubSignupAbandoned"] = "subProductAbandoned";
    PermutiveAction["NewsletterSubscribeToAll"] = "newsletterSubscribeAll";
    PermutiveAction["NewsletterUnsubscribe"] = "newsletterUnsubscribe";
})(PermutiveAction || (PermutiveAction = {}));
var PermutiveEventCategory;
(function (PermutiveEventCategory) {
    PermutiveEventCategory["Newsletter"] = "newsletter";
    PermutiveEventCategory["PremiumSubscription"] = "premium-subscription";
})(PermutiveEventCategory || (PermutiveEventCategory = {}));
var PermutiveTrackingType;
(function (PermutiveTrackingType) {
    PermutiveTrackingType["Subscription"] = "subscription";
})(PermutiveTrackingType || (PermutiveTrackingType = {}));
const permutiveIdentify = (email_sha256) => __awaiter(void 0, void 0, void 0, function* () {
    const { permutive } = window;
    if (!permutive)
        return;
    yield permutive.identify([
        {
            id: email_sha256,
            tag: 'email_sha256'
        }
    ]);
});
const pushToDataLayer = (data) => {
    if (typeof window !== 'undefined') {
        const dataLayer = window.dataLayer || [];
        window.dataLayer = dataLayer;
        dataLayer.push(data);
    }
};
const trackEmailCapture = (channelKey) => {
    pushToDataLayer({
        event: 'email-capture',
        emailCaptureSource: channelKey
    });
};
const trackValidatedEmailCapture = (siteId, loginType, id) => {
    let captureSource;
    if (window === null || window === void 0 ? void 0 : window.TEMPEST_METER_WALL) {
        const availableViews = window.TEMPEST_METER_WALL.available || 0;
        const usedViews = window.TEMPEST_METER_WALL.used || 0;
        captureSource = `${siteId || 'generic'}-metered-wall-${loginType}-${usedViews}-of-${availableViews}`;
    }
    else {
        captureSource = `${siteId || 'generic'}-metered-wall-${loginType}`;
    }
    pushToDataLayer({
        event: 'validated-email-capture',
        emailCaptureSource: captureSource,
        memberId: id,
        memberIdSource: 1
    });
};
var PaymentInfoFillType;
(function (PaymentInfoFillType) {
    PaymentInfoFillType["Auto"] = "auto";
    PaymentInfoFillType["Manual"] = "manual";
    PaymentInfoFillType["Zip"] = "zip";
})(PaymentInfoFillType || (PaymentInfoFillType = {}));

const UserContext = React.createContext({
    currentUserLogin: undefined,
    updateUserLogin: userLogin => { },
    removeUserLogin: () => null,
    updateRgisCookie: rgisCookie => null
});
const UserContextProvider = ({ userCookieConfig, children }) => {
    const EmailHashesKey = 'emailHashes';
    let store = null;
    const getUserLoginFromCookies = () => {
        store = new UserLoginStore(userCookieConfig);
        const rgisCookie = store.getRgisCookie();
        const userTokenCookie = store.getUserTokenCookie();
        const coralTokenCookie = store.getCoralTokenCookie();
        let userLoginFromCookies = {};
        if (rgisCookie) {
            userLoginFromCookies.c3RGIS = rgisCookie;
        }
        if (userTokenCookie) {
            userLoginFromCookies.userToken = userTokenCookie;
        }
        if (coralTokenCookie) {
            userLoginFromCookies.coralToken = coralTokenCookie;
        }
        userLoginFromCookies = Object.keys(userLoginFromCookies).length > 0 ? userLoginFromCookies : undefined;
        return userLoginFromCookies;
    };
    const [userLogin, setUserLogin] = useState(getUserLoginFromCookies);
    const updateUserLogin = (newUserLogin, newUserResponse = {}) => {
        store = new UserLoginStore(userCookieConfig);
        store.setUserLogin(newUserLogin);
        setUserLogin(Object.assign(Object.assign({}, newUserLogin), { email: newUserResponse.email }));
        if (newUserResponse === null || newUserResponse === void 0 ? void 0 : newUserResponse.emailHashes) {
            setItem(EmailHashesKey, JSON.stringify(newUserResponse.emailHashes));
            const sha256 = newUserResponse.emailHashes.find(item => item.alg === 'sha256');
            if (sha256) {
                permutiveIdentify(sha256.digest);
            }
        }
    };
    const updateRgisCookie = (rgisCookie) => {
        if (!store) {
            store = new UserLoginStore(userCookieConfig);
        }
        store.setRgisCookie(rgisCookie);
    };
    const removeUserLogin = () => {
        store = new UserLoginStore(userCookieConfig);
        store.removeUserLogin();
        setUserLogin(undefined);
        removeItem(EmailHashesKey);
    };
    return (React.createElement(UserContext.Provider, { value: { currentUserLogin: userLogin, updateUserLogin, removeUserLogin, updateRgisCookie } }, children));
};

const enter = (func) => (e) => {
    if (e.key === 'Enter') {
        func(e);
    }
};
const isValidUrl = (url) => {
    if (!url) {
        return false;
    }
    return /^(http|https)?:\/\//i.test(url);
};
const validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const isValidEmail = (email) => {
    if (!email)
        return false;
    return Boolean(email.match(validEmailRegex));
};

var TaigaValidationFailureReason;
(function (TaigaValidationFailureReason) {
    TaigaValidationFailureReason["NotAvailable"] = "That username is not available";
    TaigaValidationFailureReason["TooShort"] = "Username too short";
    TaigaValidationFailureReason["TooLong"] = "Username too long";
    TaigaValidationFailureReason["ProhibitedCharacter"] = "Username can contain only letters, numbers, and the characters -_.$*'";
    TaigaValidationFailureReason["UserHasExistingDisplayName"] = "You already have a username";
})(TaigaValidationFailureReason || (TaigaValidationFailureReason = {}));
const validateUsername = (username, taigaApiBase) => {
    const [usernameError, setUsernameError] = useState(undefined);
    useEffect(() => {
        const validate = () => __awaiter(void 0, void 0, void 0, function* () {
            const validResp = yield fetch(taigaApiBase + '/api/user/validate/displayName', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ displayName: username })
            }).then(r => r.json());
            if (validResp.isValid) {
                setUsernameError('');
            }
            else {
                const reason = validResp.reason;
                const errorMessage = TaigaValidationFailureReason[reason];
                setUsernameError(errorMessage);
            }
        });
        if (username) {
            validate();
        }
    }, [username]);
    return usernameError;
};

const useLoginFlow = (_a) => {
    var { authConfig, channelKey = 'company', userLogin: userLoginProp, taigaLoginCodeRequestProps } = _a, props = __rest(_a, ["authConfig", "channelKey", "userLogin", "taigaLoginCodeRequestProps"]);
    const [email, setEmail] = useState(props.emailJwt ? JSON.parse(atob(props.emailJwt.split('.')[1])).email : props.email || '');
    const [emailError, setEmailError] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [loginError, setLoginError] = useState('');
    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState(undefined);
    const [loginStep, setLoginStep] = useState((props === null || props === void 0 ? void 0 : props.email)
        ? LoginStep.SendCodeEmail
        : (userLoginProp === null || userLoginProp === void 0 ? void 0 : userLoginProp.userToken) || (userLoginProp === null || userLoginProp === void 0 ? void 0 : userLoginProp.c3RGIS)
            ? LoginStep.GetUsername
            : LoginStep.GetEmail);
    const [loginCodeId, setLoginCodeId] = useState();
    const [claim, setClaim] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [taigaAuthState, setTaigaAuthState] = useState({ userLogin: userLoginProp });
    const [loginPropFired, setLoginPropFired] = useState(false);
    const { siteId, taigaApiBase } = taigaLoginCodeRequestProps || {};
    let { deviceType, location } = taigaLoginCodeRequestProps || {};
    let isMounted;
    if (typeof window !== 'undefined') {
        deviceType = deviceType || window.navigator.userAgent;
        location = location || window.location.href;
    }
    const tempUsernameError = validateUsername(username, taigaLoginCodeRequestProps === null || taigaLoginCodeRequestProps === void 0 ? void 0 : taigaLoginCodeRequestProps.taigaApiBase);
    if (tempUsernameError !== usernameError) {
        setUsernameError(tempUsernameError);
    }
    const handlePromiseCountryCode = (promiseCountryCode) => {
        promiseCountryCode
            .then((data) => {
            setCountryCode((data === null || data === void 0 ? void 0 : data.countryCode) || '');
        })
            .catch((err) => {
            console.error(err);
        });
    };
    const taigaCreate = () => {
        const { claimState, component = 'SyncLogin' } = taigaLoginCodeRequestProps;
        setLoading(true);
        const loginCodeEndpoint = props.baseFetchUrl
            ? props.baseFetchUrl + '/login-code'
            : `${taigaApiBase || 'https://taiga.maven.io'}/api/user/loginCode`;
        fetch$1(loginCodeEndpoint, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                siteId,
                claimState,
                deviceType,
                location,
                component
            })
        })
            .then(r => {
            return r.json().then(body => ({ status: r.status, body }));
        })
            .then(({ status, body }) => {
            var _a, _b;
            if (status === 200) {
                setLoginCodeId(body.clientCode);
                setLoginStep(LoginStep.WaitForCode);
                if (!countryCode) {
                    const promiseCountryCode = (_b = (_a = window.GdprStatus) === null || _a === void 0 ? void 0 : _a.mavenContextPromise) !== null && _b !== void 0 ? _b : fetch$1('https://uid.mavencoalition.io/v3').then(res => res.json());
                    handlePromiseCountryCode(promiseCountryCode);
                }
            }
            else {
                if ((body === null || body === void 0 ? void 0 : body.message) === 'Invalid email address') {
                    setLoginStep(LoginStep.GetEmail);
                    setEmailError('Invalid email address, please try again');
                }
                else {
                    setLoginStep(LoginStep.GetEmail);
                    setEmailError('Unknown error occurred, please try again');
                }
            }
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const taigaClaim = () => {
        const { onLogin = response => { } } = taigaLoginCodeRequestProps;
        setLoading(true);
        const loginCodeClaimsEndpoint = props.baseFetchUrl
            ? props.baseFetchUrl + '/login-code-claims'
            : `${taigaApiBase || 'https://taiga.maven.io'}/api/user/loginCode/claim`;
        fetch$1(loginCodeClaimsEndpoint, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                deviceType,
                clientCode: loginCodeId,
                claimShortCode: claim.replace(/\W/g, ''),
                siteKeyword: channelKey,
                countryCode
            })
        })
            .then(response => {
            if (response.ok) {
                return response.json();
            }
            else if (response.status === 403) {
                setLoginError('Invalid Code');
                setLoginStep(LoginStep.WaitForCode);
                return { isError: true };
            }
            throw new Error(response.statusText);
        })
            .then((checkCodeResp) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (checkCodeResp.isError) {
                setLoginError('Invalid Code');
                setLoginStep(LoginStep.WaitForCode);
                setLoading(false);
                return;
            }
            setClaim('');
            const tokens = {
                userToken: (_b = (_a = checkCodeResp.tokens) === null || _a === void 0 ? void 0 : _a.userToken) === null || _b === void 0 ? void 0 : _b.token,
                c3RGIS: (_c = checkCodeResp.tokens) === null || _c === void 0 ? void 0 : _c.rgis,
                coralToken: (_e = (_d = checkCodeResp.tokens) === null || _d === void 0 ? void 0 : _d.coralToken) === null || _e === void 0 ? void 0 : _e.token
            };
            const userType = checkCodeResp.operation === 'Login' ? 'returning' : 'new';
            setTaigaAuthState({ userLogin: tokens, userResponse: { emailHashes: (_f = checkCodeResp.userResponse) === null || _f === void 0 ? void 0 : _f.emailHashes } });
            onLogin(Object.assign(Object.assign({}, tokens), { userType }), checkCodeResp.userResponse);
            if (!isMounted) {
                return;
            }
            setLoginPropFired(true);
            if (props.usernameBehavior === LoginUsernameCollectionBehavior.None || ((_g = checkCodeResp.tokens) === null || _g === void 0 ? void 0 : _g.coralToken)) {
                setLoginStep(LoginStep.Complete);
            }
            else {
                setLoginStep(LoginStep.GetUsername);
            }
        })
            .catch(err => {
            console.error(err);
        })
            .finally(() => {
            if (isMounted) {
                setLoading(false);
            }
        });
    };
    const taigaSetUsername = () => {
        var _a, _b, _c, _d;
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if ((_a = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _a === void 0 ? void 0 : _a.c3RGIS) {
            headers.append('x-rgis', (_b = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _b === void 0 ? void 0 : _b.c3RGIS);
        }
        if ((_c = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _c === void 0 ? void 0 : _c.userToken) {
            headers.append('x-user-token', (_d = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _d === void 0 ? void 0 : _d.userToken);
        }
        fetch$1(`${taigaApiBase}/api/user/displayName`, {
            method: 'put',
            headers,
            body: JSON.stringify({ displayName: username, siteId })
        })
            .then(resp => resp.json())
            .then((resp) => {
            var _a;
            setTaigaAuthState(Object.assign(Object.assign({}, taigaAuthState), { userLogin: Object.assign(Object.assign({}, taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin), { coralToken: (_a = resp.coralToken) === null || _a === void 0 ? void 0 : _a.token }) }));
            setLoginPropFired(false);
            setLoginStep(LoginStep.Complete);
        })
            .finally(() => setLoading(false));
    };
    const loginStepEffect = () => {
        switch (loginStep) {
            case LoginStep.SendCodeEmail:
                taigaCreate();
                break;
            case LoginStep.CheckCode:
                taigaClaim();
                break;
            case LoginStep.SendC3LoginCredentials:
                setLoading(true);
                const { onLogin = response => { } } = taigaLoginCodeRequestProps;
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                fetch$1(`${taigaApiBase}/api/user/classicLogin`, {
                    method: 'post',
                    headers,
                    body: JSON.stringify({
                        username: email,
                        password
                    })
                })
                    .then(r => r.json())
                    .catch(() => setLoginError('Unable to login'))
                    .then(checkResp => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    setEmail('');
                    setPassword('');
                    if (((_a = checkResp === null || checkResp === void 0 ? void 0 : checkResp.tokens) === null || _a === void 0 ? void 0 : _a.userToken) || ((_b = checkResp === null || checkResp === void 0 ? void 0 : checkResp.tokens) === null || _b === void 0 ? void 0 : _b.rgis)) {
                        const tokens = {
                            userToken: (_d = (_c = checkResp.tokens) === null || _c === void 0 ? void 0 : _c.userToken) === null || _d === void 0 ? void 0 : _d.token,
                            c3RGIS: (_e = checkResp.tokens) === null || _e === void 0 ? void 0 : _e.rgis,
                            coralToken: (_g = (_f = checkResp.tokens) === null || _f === void 0 ? void 0 : _f.coralToken) === null || _g === void 0 ? void 0 : _g.token
                        };
                        const userType = checkResp.operation === 'Login' ? 'returning' : 'new';
                        setTaigaAuthState({
                            userLogin: tokens,
                            userResponse: { emailHashes: (_h = checkResp.userResponse) === null || _h === void 0 ? void 0 : _h.emailHashes }
                        });
                        onLogin(Object.assign(Object.assign({}, tokens), { userType }), checkResp.userResponse);
                        if (props.usernameBehavior === LoginUsernameCollectionBehavior.None || ((_j = checkResp.tokens) === null || _j === void 0 ? void 0 : _j.coralToken)) {
                            setLoginStep(LoginStep.Complete);
                        }
                        else {
                            setLoginStep(LoginStep.GetUsername);
                        }
                    }
                    else {
                        setLoginError('Email/Password is invalid');
                        setLoginStep(LoginStep.ClassicLogin);
                    }
                })
                    .finally(() => setLoading(false));
                break;
            case LoginStep.SetUsername:
                taigaSetUsername();
                break;
            case LoginStep.Complete:
                if (!loginPropFired) {
                    if (taigaLoginCodeRequestProps.onLogin && (taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin)) {
                        taigaLoginCodeRequestProps.onLogin(taigaAuthState.userLogin, taigaAuthState.userResponse);
                        setLoginPropFired(true);
                    }
                }
                break;
        }
    };
    useEffect(() => {
        isMounted = true;
        loginStepEffect();
        return () => {
            isMounted = false;
        };
    }, [loginStep]);
    const getStepFunc = () => {
        let step = () => { };
        if (loginStep === LoginStep.GetEmail) {
            step = () => {
                const emailIsValid = isValidEmail(email);
                setEmailError(!emailIsValid ? 'Invalid email format' : '');
                if (!emailIsValid)
                    return;
                setLoginStep(LoginStep.SendCodeEmail);
            };
        }
        else if (loginStep === LoginStep.ClassicLogin) {
            step = () => {
                setLoginStep((authConfig === null || authConfig === void 0 ? void 0 : authConfig.useSalishLogin) ? LoginStep.SendSalishLoginCredentials : LoginStep.SendC3LoginCredentials);
            };
        }
        else if (loginStep === LoginStep.WaitForCode) {
            step = () => claim.length === 6 && setLoginStep(LoginStep.CheckCode);
        }
        else if (loginStep === LoginStep.GetUsername) {
            step = () => usernameError === '' && setLoginStep(LoginStep.SetUsername);
        }
        return step;
    };
    return {
        email,
        emailError,
        setEmail,
        setPassword,
        password,
        loading,
        loginError,
        loginStep,
        username,
        setUsername,
        usernameError,
        setLoginStep,
        claim,
        setClaim,
        taigaAuthState,
        stepFunc: getStepFunc()
    };
};
var useLoginFlow$1 = useLoginFlow;

const dialogMinHeight = 300;
const useLoginStyles = makeStyles(theme => ({
    loading: {
        width: '100%',
        minHeight: dialogMinHeight,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexFlow: 'column'
    },
    progressBar: {
        color: theme.palette.text.secondary
    },
    logo: {
        fill: theme.palette.text.primary
    },
    logoImg: {
        maxHeight: 25,
        maxWidth: 125
    },
    buttonGrey: {
        color: props => props.textColor,
        textTransform: 'uppercase',
        '&:hover': {
            color: props => props.textHoverColor
        }
    },
    altLoginTxt: {
        fontSize: 12,
        opacity: 0.7,
        cursor: 'pointer'
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'column',
        padding: '32px 32px 0 32px',
        '& svg': {
            marginBottom: theme.spacing()
        }
    },
    mavenDialog: {
        backgroundColor: props => props.backgroundColor,
        color: props => props.textColor,
        minHeight: props => (props.loginStep === LoginStep.Complete ? 0 : dialogMinHeight),
        borderRadius: 16,
        minWidth: '288px',
        width: '375px'
    },
    label: {
        textTransform: 'uppercase',
        textAlign: 'center'
    },
    close: {
        position: 'absolute',
        top: 30,
        left: 25,
        '& path': {
            stroke: 'none'
        }
    },
    content: {
        display: 'grid',
        alignContent: 'center',
        padding: '8px 30px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    },
    textField: {
        color: props => props.textColor,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        padding: '20px 0'
    },
    textFieldDual: {
        color: props => props.textColor,
        borderBottom: '1px solid',
        padding: '13px 0'
    },
    input: {
        color: props => props.textColor,
        '& input': {
            display: 'block',
            textAlign: 'center',
            padding: '5px 0'
        },
        '& input::placeholder': {
            display: 'block',
            textAlign: 'center'
        }
    },
    policy: {
        padding: '15px 30px 5px',
        textAlign: 'center',
        display: 'block'
    },
    actions: {
        alignSelf: 'flex-end',
        padding: '15px 20px',
        justifyContent: 'flex-end',
        marginBottom: '20px',
        '& button:disabled': {
            opacity: '.4'
        },
        '& span': {
            zIndex: 3
        }
    },
    arrow: {
        width: '18px'
    }
}));
var useLoginStyles$1 = useLoginStyles;

const claimCodeLength = 6;
const AuthCodeInputView = ({ authTheme, step, loginFlow }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { align: "center", color: "inherit" },
                "Please enter the code we sent to ",
                loginFlow.email,
                "."),
            React.createElement(DialogContentText, { align: "center" }, loginFlow.loginError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.loginError))),
            React.createElement(TextField, { autoFocus: true, className: classes.textField, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onChange: e => loginFlow.setClaim(e.target.value.replace(/\W/g, '')), value: loginFlow.claim, margin: "dense", id: "code", placeholder: "Code", onKeyPress: enter(step) })),
        React.createElement(DialogActions, { className: classes.actions },
            React.createElement(Button, { className: classes.buttonGrey, color: "default", onClick: step, disabled: loginFlow.claim.length !== claimCodeLength, "data-testid": "auth-code-login-btn" },
                "Login",
                React.createElement(ChevronRight, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var AuthCodeInputView$1 = AuthCodeInputView;

const useStyles$5 = makeStyles$1((theme) => {
    var _a;
    return ({
        root: {
            color: ((_a = theme.palette.interactive) === null || _a === void 0 ? void 0 : _a.main) || theme.palette.text.primary,
            padding: 0,
            border: 'none',
            background: 'transparent',
            textTransform: 'none',
            verticalAlign: 'unset',
            fontSize: 'inherit',
            textAlign: 'left'
        }
    });
});
const LinkButton = props => {
    const classes = useStyles$5();
    return (React.createElement(ButtonBase, Object.assign({}, props, { className: clsx(classes.root, props === null || props === void 0 ? void 0 : props.className), disableRipple: true }), props.children));
};

const useStyles$4 = makeStyles(theme => ({
    altLoginTxt: {
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.text.hint
    }
}));
const SwapLoginButton = ({ labelTxt, setLoginStep }) => {
    const classes = useStyles$4();
    return (React.createElement(LinkButton, { onClick: setLoginStep, className: classes.altLoginTxt }, labelTxt));
};
var SwapLoginButton$1 = SwapLoginButton;

const ClassicInputView = ({ authTheme, backLabel = '< Standard login', forgotPassword, step, loginFlow }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { className: classes.label, color: "inherit" }, "Classic Login"),
            React.createElement(DialogContentText, { align: "center" }, loginFlow.loginError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.loginError))),
            React.createElement(TextField, { className: classes.textFieldDual, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onKeyPress: enter(step), autoFocus: true, onChange: e => loginFlow.setEmail(e.target.value), value: loginFlow.email, margin: "dense", id: "email", placeholder: "Email Address", type: "email" }),
            React.createElement(TextField, { className: classes.textFieldDual, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onKeyPress: enter(step), autoFocus: true, onChange: e => loginFlow.setPassword(e.target.value), value: loginFlow.password, margin: "dense", id: "password", placeholder: "Password", type: "password" }),
            forgotPassword && (React.createElement(Box, null,
                React.createElement(Typography, { className: classes.policy, align: "center", variant: "caption", color: "inherit" },
                    React.createElement(Link, { color: "inherit", href: forgotPassword, target: "_blank" }, "Forgot Password"))))),
        React.createElement(DialogActions, { className: classes.actions, style: { justifyContent: 'space-between' } },
            React.createElement(SwapLoginButton$1, { labelTxt: backLabel, setLoginStep: () => loginFlow.setLoginStep(LoginStep.GetEmail) }),
            React.createElement(Button, { className: classes.buttonGrey, onClick: step, disabled: !(loginFlow.email.length > 0 && loginFlow.password.length > 0), "data-testid": "classic-view-login-btn" },
                "Login",
                React.createElement(ChevronRight, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var ClassicInputView$1 = ClassicInputView;

const useDarkButtonStyles = makeStyles({
    root: {
        textTransform: 'uppercase',
        color: 'white',
        '&:hover': {
            color: 'white'
        },
        background: 'black',
        border: 0,
        borderRadius: 3,
        height: 48,
        margin: '0 0 40px 0'
    }
});
const EmailInputView = ({ authTheme, classicSwapLabel = 'Have a password instead?', step, topLabel = 'Continue with email', loginFlow, showClassicLogin }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    const darkButtonClass = useDarkButtonStyles();
    const disableNext = () => {
        const { email } = loginFlow;
        return !(email && email.indexOf('@') > 0 && email.indexOf('@') < email.length - 1);
    };
    let showC3LoginOption = false;
    if (showClassicLogin) {
        showC3LoginOption = true;
    }
    else {
        if (typeof window !== 'undefined') {
            const domainsThatShowC3Login = ['thestreet'];
            showC3LoginOption = domainsThatShowC3Login.some(x => window.location.hostname.includes(x));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { className: classes.label, color: 'inherit' }, topLabel),
            React.createElement(DialogContentText, null, loginFlow.emailError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.emailError))),
            React.createElement(TextField, { className: classes.textField, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onKeyPress: enter(step), autoFocus: true, onChange: e => loginFlow.setEmail(e.target.value), value: loginFlow.email, margin: "dense", id: "email", placeholder: "Email Address", type: "email" }),
            React.createElement(Box, null,
                React.createElement(Typography, { className: classes.policy, align: "center", variant: "caption" },
                    "Signing up to post comments will add you to our newsletter. By continuing you agree to The Arena Group's ",
                    React.createElement(Link, { color: "primary", href: "https://maven.io/company/pages/privacy", target: "_blank" }, "Privacy Policy"),
                    ' ',
                    "and",
                    ' ',
                    React.createElement(Link, { color: "primary", href: "https://maven.io/company/pages/terms", target: "_blank" }, "Terms of Use.")))),
        React.createElement(DialogActions, { className: classes.actions, style: showC3LoginOption ? { justifyContent: 'space-between' } : {} }, showC3LoginOption && (React.createElement(SwapLoginButton$1, { labelTxt: classicSwapLabel, setLoginStep: () => loginFlow.setLoginStep(LoginStep.ClassicLogin) }))),
        React.createElement(Typography, { align: "center" },
            React.createElement(Button, { className: darkButtonClass.root, onClick: step, disabled: disableNext(), "data-testid": "email-view-next-btn", variant: "contained" },
                "Continue",
                React.createElement(ChevronRight, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var EmailInputView$1 = EmailInputView;

const CloseIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4714 4.47145C12.7318 4.2111 12.7318 3.78899 12.4714 3.52864C12.2111 3.26829 11.789 3.26829 11.5286 3.52864L8.00001 7.05723L4.47141 3.52864C4.21107 3.26829 3.78896 3.26829 3.52861 3.52864C3.26826 3.78899 3.26826 4.2111 3.52861 4.47145L7.0572 8.00004L3.52861 11.5286C3.26826 11.789 3.26826 12.2111 3.52861 12.4714C3.78896 12.7318 4.21107 12.7318 4.47141 12.4714L8.00001 8.94285L11.5286 12.4714C11.789 12.7318 12.2111 12.7318 12.4714 12.4714C12.7318 12.2111 12.7318 11.789 12.4714 11.5286L8.94282 8.00004L12.4714 4.47145Z", fill: "black" })));
const useStyles$3 = makeStyles(theme => {
    const mavenTheme = theme;
    return {
        filled: {
            '& path': {
                fill: 'currentColor',
                stroke: 'currentColor'
            }
        },
        notFilled: {
            '& path': {
                fill: 'none',
                stroke: 'currentColor'
            }
        },
        thin: {
            '& path': {
                fill: 'currentColor',
                stroke: 'none'
            }
        },
        full: {
            width: '100%',
            height: '100%'
        },
        large: {
            width: mavenTheme.icon.large,
            height: mavenTheme.icon.large
        },
        medium: {
            width: mavenTheme.icon.normal,
            height: mavenTheme.icon.normal
        },
        small: {
            width: mavenTheme.icon.small,
            height: mavenTheme.icon.small
        }
    };
});
const Icon = props => {
    const classes = useStyles$3();
    const cs = props.filled !== undefined ? [props.filled ? classes.filled : classes.notFilled] : [];
    if (props.thin) {
        cs.push(classes.thin);
    }
    if (props.className) {
        cs.push(props.className);
    }
    switch (props.size) {
        case RelativeSize.Full:
            cs.push(classes.full);
            break;
        case RelativeSize.Large:
            cs.push(classes.large);
            break;
        case RelativeSize.Medium:
            cs.push(classes.medium);
            break;
        case RelativeSize.Small:
            cs.push(classes.small);
            break;
    }
    return (React.createElement("svg", { className: cs.join(' '), viewBox: props.viewBox },
        props.title && React.createElement("title", null, props.title),
        props.children));
};
const TheArenaGroupLogo = ({ className, fill = '#ffffff', width = 150, height = 80 }) => {
    return (React.createElement("svg", { className: className, x: "0px", y: "0px", viewBox: "0 0 864 432", width: width, height: height, xmlSpace: "preserve" },
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { fill: fill, d: "M215.6,112.4c0.7-0.2,1.1-0.8,0.9-1.5c-0.2-0.7-0.8-1.1-1.5-0.9c-0.7,0.2-1.1,0.8-0.9,1.5\n        C214.3,112.1,214.9,112.5,215.6,112.4" }),
                React.createElement("path", { fill: fill, d: "M227.1,139.4c1,0.5,2.1,0,2.6-0.9c0.5-1,0-2.1-0.9-2.6c-1-0.5-2.1,0-2.6,0.9\n        C225.7,137.8,226.1,138.9,227.1,139.4" }),
                React.createElement("path", { fill: fill, d: "M240.4,170.7c2.9,1.9,6.8,1.2,8.7-1.7c1.9-2.9,1.2-6.8-1.7-8.7c-2.9-1.9-6.8-1.2-8.7,1.7\n        C236.8,164.9,237.5,168.8,240.4,170.7" }),
                React.createElement("path", { fill: fill, d: "M206.3,228.9c4,1.8,8.7,0.1,10.6-3.9c1.8-4,0.1-8.7-3.9-10.6c-4-1.8-8.7-0.1-10.6,3.9\n        C200.6,222.4,202.3,227.1,206.3,228.9" }),
                React.createElement("path", { fill: fill, d: "M188.6,155.3c0.8-0.6,1-1.8,0.4-2.6c-0.6-0.8-1.8-1-2.6-0.4c-0.8,0.6-1,1.8-0.4,2.6\n        C186.6,155.7,187.8,155.9,188.6,155.3" }),
                React.createElement("path", { fill: fill, d: "M204.2,181.8c1.3-0.8,1.7-2.5,0.9-3.8c-0.8-1.3-2.5-1.7-3.9-0.9c-1.3,0.8-1.7,2.5-0.9,3.8\n        C201.1,182.2,202.9,182.6,204.2,181.8" }),
                React.createElement("path", { fill: fill, d: "M257.5,91.3c1.1-0.4,1.7-1.6,1.3-2.7c-0.4-1.1-1.6-1.7-2.7-1.3c-1.1,0.4-1.7,1.6-1.3,2.7\n        C255.2,91.1,256.4,91.7,257.5,91.3" }),
                React.createElement("path", { fill: fill, d: "M285.6,161.7c3.9,3.4,9.9,3,13.3-1c3.4-3.9,3-9.9-0.9-13.3c-3.9-3.4-9.9-3-13.3,0.9\n        C281.2,152.3,281.6,158.3,285.6,161.7" }),
                React.createElement("path", { fill: fill, d: "M274.5,119.9c2.1-1.8,2.3-4.8,0.5-6.9c-1.8-2.1-4.8-2.3-6.9-0.5c-2.1,1.8-2.3,4.8-0.5,6.9\n        C269.4,121.4,272.5,121.6,274.5,119.9" }),
                React.createElement("path", { fill: fill, d: "M304.8,213.2c7.1,5.3,17.2,3.8,22.5-3.4c5.3-7.1,3.8-17.2-3.4-22.5c-7.1-5.3-17.2-3.8-22.5,3.4\n        C296.2,197.9,297.7,207.9,304.8,213.2" }),
                React.createElement("path", { fill: fill, d: "M130.3,241.9c1.5,1.2,3.7,0.9,4.9-0.6c1.2-1.5,0.9-3.7-0.6-4.9c-1.5-1.2-3.7-0.9-4.9,0.6\n        C128.5,238.5,128.8,240.7,130.3,241.9" }),
                React.createElement("path", { fill: fill, d: "M243.3,69c0.5,0.3,1.1,0.2,1.4-0.3c0.3-0.5,0.2-1.1-0.3-1.4c-0.5-0.3-1.1-0.2-1.4,0.3\n        C242.7,68,242.8,68.7,243.3,69" }),
                React.createElement("path", { fill: fill, d: "M251.6,222c5.5,3.5,12.8,1.9,16.3-3.6c3.5-5.5,1.9-12.8-3.6-16.3c-5.5-3.5-12.8-1.9-16.3,3.6\n        C244.5,211.2,246.1,218.5,251.6,222" }),
                React.createElement("path", { fill: fill, d: "M233.3,274.7c3.6-7,0.8-15.6-6.2-19.2c-7-3.6-15.6-0.8-19.2,6.2c-3.6,7-0.8,15.6,6.2,19.2\n        C221.1,284.5,229.7,281.7,233.3,274.7" }),
                React.createElement("path", { fill: fill, d: "M292.5,273.3c5.5-9,2.6-20.8-6.4-26.3c-9-5.5-20.8-2.6-26.3,6.4c-5.5,9-2.6,20.8,6.4,26.3\n        C275.2,285.1,287,282.3,292.5,273.3" }),
                React.createElement("path", { fill: fill, d: "M183.6,276.2c1.7-5.1-1-10.7-6.1-12.4c-5.1-1.7-10.7,1-12.4,6.1c-1.7,5.1,1,10.7,6.1,12.4\n        C176.3,284,181.9,281.3,183.6,276.2" }),
                React.createElement("path", { fill: fill, d: "M188.4,308.8c-8.6-3.7-18.5,0.3-22.2,8.9c-3.7,8.6,0.3,18.5,8.9,22.2c8.6,3.7,18.5-0.3,22.2-8.9\n        C201,322.4,197,312.5,188.4,308.8" }),
                React.createElement("path", { fill: fill, d: "M246.2,304.5c-10.9-5.7-24.4-1.5-30.1,9.4c-5.7,10.9-1.5,24.4,9.4,30.1c10.9,5.7,24.4,1.5,30.1-9.4\n        C261.3,323.7,257.1,310.2,246.2,304.5" }),
                React.createElement("path", { fill: fill, d: "M379.6,291c-18.4-1.5-34.5,12.1-36,30.5c-1.5,18.4,12.1,34.5,30.5,36c18.4,1.5,34.5-12.1,36-30.5\n        C411.6,308.6,397.9,292.5,379.6,291" }),
                React.createElement("path", { fill: fill, d: "M363.3,272.4c7.7-11.5,4.6-27-6.8-34.7c-11.5-7.7-27-4.6-34.7,6.8c-7.7,11.5-4.6,27,6.8,34.7\n        C340,286.9,355.6,283.9,363.3,272.4" }),
                React.createElement("path", { fill: fill, d: "M137.9,283.2c3-0.5,5-3.4,4.5-6.4c-0.5-3-3.4-5-6.4-4.5c-3,0.5-5,3.4-4.5,6.4\n        C132,281.7,134.9,283.7,137.9,283.2" }),
                React.createElement("path", { fill: fill, d: "M314.8,300.2c-13.3-7.7-30.3-3.3-38,10c-7.7,13.3-3.3,30.3,10,38c13.3,7.7,30.3,3.3,38-10\n        C332.5,325,328.1,307.9,314.8,300.2" }),
                React.createElement("path", { fill: fill, d: "M102.4,285.3c2,1.4,4.7,0.8,6-1.1c1.4-2,0.8-4.7-1.1-6c-2-1.4-4.7-0.8-6,1.1C100,281.3,100.5,284,102.4,285.3\n        " }),
                React.createElement("path", { fill: fill, d: "M80.6,320c-2.4-1.5-5.6-0.8-7.2,1.6c-1.5,2.4-0.8,5.6,1.6,7.2c2.4,1.5,5.6,0.8,7.2-1.6\n        C83.7,324.7,83,321.5,80.6,320" }),
                React.createElement("path", { fill: fill, d: "M170.2,234.9c2.2-0.7,3.4-3,2.7-5.1c-0.7-2.2-3-3.4-5.1-2.7c-2.2,0.7-3.4,3-2.7,5.1\n        C165.8,234.4,168.1,235.6,170.2,234.9" }),
                React.createElement("path", { fill: fill, d: "M104.2,317.4c-3.9,0.4-6.7,3.9-6.3,7.7c0.4,3.9,3.9,6.7,7.7,6.3c3.9-0.4,6.7-3.9,6.3-7.7\n        C111.5,319.8,108,317,104.2,317.4" }),
                React.createElement("path", { fill: fill, d: "M141.4,313.1c-6.2-1.6-12.6,2.1-14.2,8.3c-1.6,6.2,2.1,12.6,8.3,14.2c6.2,1.6,12.6-2.1,14.2-8.3\n        C151.3,321.1,147.6,314.7,141.4,313.1" }),
                React.createElement("path", { fill: fill, d: "M165,189.7c-1.1-1-2.7-1-3.7,0.1c-1,1.1-1,2.7,0.1,3.7c1.1,1,2.7,1,3.7-0.1\n        C166.2,192.3,166.1,190.7,165,189.7" })),
            React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("polygon", { fill: !className && fill, points: "568.7,153.7 568.7,172.5 532.5,172.5 532.5,153.7 522.3,153.7 522.3,201.6 532.5,201.6 532.5,181\n          568.7,181 568.7,201.6 578.8,201.6 578.8,153.7 \t\t\t" }),
                    React.createElement("polygon", { fill: !className && fill, points: "510.5,153.7 510.5,163.5 486,163.5 486,201.6 475.9,201.6 475.9,163.5 451.4,163.5 451.4,153.7\n          " }),
                    React.createElement("polygon", { fill: !className && fill, points: "641.6,163 641.6,153.7 590.7,153.7 590.7,201.6 641.6,201.6 641.6,192.3 600,192.3 600,181\n          638.7,181 638.7,172.5 600,172.5 600,163 \t\t\t" })),
                React.createElement("g", null,
                    React.createElement("path", { fill: !className && fill, d: "M450,321.7c0-12.9,10-23.3,22.8-23.3c9.6,0,17.3,6,20.6,14.6l-3.6,0.7c-2.8-7-8.9-11.7-16.9-11.7\n          c-10.9,0-19.1,8.8-19.1,19.7c0,10.8,8,19.7,19.1,19.7c10.1,0,16.9-7.4,17.8-17.3h-18l-0.1-3.3h21.7v1c0,12.8-8.6,23-21.5,23\n          C459.8,344.9,450,334.4,450,321.7z" }),
                    React.createElement("path", { fill: !className && fill, d: "M502.3,309.9h3.6v7.8c2.1-5.9,7.6-9.1,15-7.9v3.7c-8.5-1.8-15,3.4-15,13.7v17.2h-3.6V309.9z" }),
                    React.createElement("path", { fill: !className && fill, d: "M523.7,327.1c0-9.8,7.7-17.8,17.6-17.8c10,0,17.6,8.1,17.6,17.8c0,9.8-7.8,17.8-17.6,17.8\n          C531.5,345,523.7,337,523.7,327.1z M555.6,327.1c0-7.9-6.3-14.4-14.2-14.4c-8,0-14.2,6.4-14.2,14.4c0,8.1,6.4,14.5,14.2,14.5\n          C549.3,341.6,555.6,335.1,555.6,327.1z" }),
                    React.createElement("path", { fill: !className && fill, d: "M566.2,330.5v-20.6h3.6v19.3c0,8.1,5.5,12.4,11.7,12.4c7.1,0,12.5-5.7,12.5-14.2v-17.5h3.6v34.5h-3.6v-7.4\n          c-2.1,4.2-6.5,7.9-13,7.9C573.2,345,566.2,339.8,566.2,330.5z" }),
                    React.createElement("path", { fill: !className && fill, d: "M606.2,309.9h3.6v7.9c2.7-4.9,7.9-8.5,14.3-8.5c9.8,0,17.4,8.1,17.4,17.8c0,10-7.7,17.8-17.4,17.8\n          c-6.4,0-11.7-3.5-14.3-8.5v21.7h-3.6V309.9z M638.1,327.1c0-7.9-6.3-14.5-14.3-14.5c-7.9,0-14.3,6.5-14.3,14.5\n          c0,8,6.3,14.5,14.3,14.5C631.7,341.6,638.1,335.3,638.1,327.1z" })),
                React.createElement("g", null,
                    React.createElement("g", null,
                        React.createElement("path", { fill: !className && fill, d: "M561.4,255.3h-17.3l24.7,20.6h14.4l-14.4-12c6.6-2.9,11.3-9.5,11.3-17.2c0-10.3-8.4-18.7-18.7-18.7h-36.1\n            v47.9h10.2v-37.7h25.9c4.7,0,8.5,3.8,8.5,8.5C569.9,251.4,566.1,255.3,561.4,255.3" })),
                    React.createElement("path", { fill: !className && fill, d: "M506.5,275.9h12.2L486.6,228h-10.8l-32.1,47.8h12.2l5.3-7.8h39.9L506.5,275.9z M467.2,259.2l14-20.4l14,20.4\n          H467.2z" }),
                    React.createElement("g", null,
                        React.createElement("g", null,
                            React.createElement("polygon", { fill: !className && fill, points: "699.2,228 699.2,263.5 664.9,228 652.9,228 652.9,275.9 663,275.9 663,240.4 697.4,275.9\n              709.4,275.9 709.4,228 \t\t\t\t\t" }))),
                    React.createElement("path", { fill: !className && fill, d: "M779.2,275.9h12.2L759.2,228h-10.8l-32.1,47.8h12.2l5.3-7.8h39.9L779.2,275.9z M739.9,259.2l14-20.4l14,20.4\n          H739.9z" }),
                    React.createElement("polygon", { fill: !className && fill, points: "641.6,237.3 641.6,228 590.7,228 590.7,275.9 641.6,275.9 641.6,266.6 600,266.6 600,255.3\n          638.7,255.3 638.7,246.8 600,246.8 600,237.3 \t\t\t" }))))));
};
const ProfileIcon = () => (React.createElement("svg", { width: "18", height: "20", viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.31328 13.2163C3.15415 12.3655 4.29463 11.8876 5.4838 11.8876H12.6579C13.8471 11.8876 14.9875 12.3655 15.8284 13.2163C16.6693 14.067 17.1417 15.2209 17.1417 16.424V18.2386C17.1417 18.7397 16.7402 19.1459 16.2449 19.1459C15.7497 19.1459 15.3482 18.7397 15.3482 18.2386V16.424C15.3482 15.7021 15.0647 15.0098 14.5602 14.4994C14.0557 13.9889 13.3714 13.7022 12.6579 13.7022H5.4838C4.7703 13.7022 4.08601 13.9889 3.58149 14.4994C3.07696 15.0098 2.79352 15.7021 2.79352 16.424V18.2386C2.79352 18.7397 2.39203 19.1459 1.89676 19.1459C1.40149 19.1459 1 18.7397 1 18.2386V16.424C1 15.2209 1.4724 14.067 2.31328 13.2163Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "0.2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.07072 2.81458C7.58492 2.81458 6.38044 4.03321 6.38044 5.53646C6.38044 7.03971 7.58492 8.25833 9.07072 8.25833C10.5565 8.25833 11.761 7.03971 11.761 5.53646C11.761 4.03321 10.5565 2.81458 9.07072 2.81458ZM4.58691 5.53646C4.58691 3.03104 6.59438 1 9.07072 1C11.5471 1 13.5545 3.03104 13.5545 5.53646C13.5545 8.04187 11.5471 10.0729 9.07072 10.0729C6.59438 10.0729 4.58691 8.04187 4.58691 5.53646Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "0.2", strokeLinecap: "round", strokeLinejoin: "round" })));

const LoginDialog = ({ authTheme, children, isStandalone, loading, logo, loginStep, onCancel, open, setOpen }) => {
    const classes = useLoginStyles$1(Object.assign(Object.assign({}, authTheme), { loginStep }));
    const headerLogo = logo ? (React.createElement("img", { src: logo, className: classes.logoImg })) : (React.createElement(TheArenaGroupLogo, { fill: '#D81919', className: classes.logo }));
    return (React.createElement(Dialog, { open: open, scroll: "body", classes: { paperScrollBody: classes.mavenDialog }, disableEscapeKeyDown: isStandalone },
        React.createElement(Box, null,
            !isStandalone && (React.createElement(ButtonBase, { className: classes.close, onClick: () => {
                    onCancel();
                    setOpen(false);
                } },
                React.createElement(CloseIcon, { size: RelativeSize.Large, filled: true }))),
            loading ? (React.createElement(DialogContent, { className: classes.loading },
                React.createElement(CircularProgress, { size: 48, className: classes.progressBar }))) : (React.createElement(React.Fragment, null,
                React.createElement(DialogTitle, { className: classes.title, disableTypography: true }, headerLogo),
                children)))));
};
var LoginDialog$1 = LoginDialog;

const UsernameInputView = ({ authTheme, step, usernameBehavior, loginFlow }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    const theme = useTheme();
    let adornment;
    if (loginFlow.usernameError === '') {
        adornment = (React.createElement(InputAdornment, { position: "end" },
            React.createElement(Check, { style: { color: theme.palette.success.main } })));
    }
    else if (loginFlow.usernameError) {
        adornment = (React.createElement(InputAdornment, { position: "end" },
            React.createElement(Error$1, { color: "error" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { className: classes.label, color: "inherit" }, usernameBehavior === LoginUsernameCollectionBehavior.Optional
                ? 'You can create a username now if you like, or you can do it later.'
                : 'A username is required to continue'),
            React.createElement(DialogContentText, null, loginFlow.usernameError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.usernameError))),
            React.createElement(TextField, { autoFocus: true, className: classes.textField, InputProps: {
                    endAdornment: adornment,
                    className: classes.input,
                    disableUnderline: true
                }, onChange: e => loginFlow.setUsername(e.target.value), value: loginFlow.username, margin: "dense", id: "username", placeholder: "Username", onKeyPress: enter(step) })),
        React.createElement(DialogActions, { className: classes.actions },
            usernameBehavior === LoginUsernameCollectionBehavior.Optional ? (React.createElement(Button, { className: classes.buttonGrey, onClick: () => loginFlow.setLoginStep(LoginStep.Complete) }, "Skip")) : null,
            React.createElement(Button, { className: classes.buttonGrey, disabled: Boolean(loginFlow.usernameError), onClick: step },
                "Next",
                React.createElement(ChevronRight, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var UsernameInputView$1 = UsernameInputView;

const TempestContext = createContext({
    siteBasePath: undefined,
    flags: []
});
const TempestContextProvider = ({ flags, siteBasePath, children }) => (React.createElement(TempestContext.Provider, { value: { flags, siteBasePath } }, children));
const useTempestContext = () => {
    return useContext(TempestContext);
};

const UserTokenCookieName = 'mut';
const SyncLogin = props => {
    var _a, _b, _c, _d;
    const { flags, siteBasePath } = useTempestContext();
    const [cookies] = useCookies([UserTokenCookieName]);
    if (flags.includes('use-new-sign-in')) {
        if ((!props.viaLogin && !props.viaLoginComplete && !cookies[UserTokenCookieName]) || props.isMeterLogin) {
            if (typeof window !== 'undefined') {
                window.location.href = `${window.location.origin}${siteBasePath !== null && siteBasePath !== void 0 ? siteBasePath : ''}/login?targetUrl=${encodeURIComponent(window.location.href)}`;
            }
            return React.createElement(React.Fragment, null);
        }
    }
    const userAuth = useContext(UserContext);
    const [open, setOpen] = useState(true);
    const completeReached = useRef(false);
    const captureReached = useRef(false);
    const isStandalone = Boolean(props.isStandalone);
    const authTheme = (_a = props.authConfig) === null || _a === void 0 ? void 0 : _a.authTheme;
    const dialogueForLoginStep = (loginFlow) => {
        var _a, _b;
        const { loginStep, stepFunc } = loginFlow;
        if (loginStep === LoginStep.GetEmail) {
            captureReached.current = false;
            completeReached.current = false;
            return (React.createElement(EmailInputView$1, { authTheme: authTheme, showClassicLogin: props.showClassicLogin, classicSwapLabel: props.classicLoginLabel, topLabel: props.label, step: stepFunc, loginFlow: loginFlow }));
        }
        else if (loginStep === LoginStep.ClassicLogin) {
            captureReached.current = false;
            completeReached.current = false;
            return (React.createElement(ClassicInputView$1, { authTheme: authTheme, forgotPassword: (_a = props.authConfig) === null || _a === void 0 ? void 0 : _a.forgotPassword, step: stepFunc, loginFlow: loginFlow }));
        }
        else if (loginStep === LoginStep.WaitForCode) {
            if (props.onCapture && !login.loading && !captureReached.current) {
                props.onCapture();
                captureReached.current = true;
            }
            return React.createElement(AuthCodeInputView$1, { authTheme: authTheme, step: stepFunc, loginFlow: loginFlow });
        }
        else if (loginStep === LoginStep.GetUsername) {
            completeReached.current = false;
            captureReached.current = false;
            return (React.createElement(UsernameInputView$1, { authTheme: authTheme, usernameBehavior: props.usernameBehavior, step: stepFunc, loginFlow: loginFlow }));
        }
        else if (loginStep === LoginStep.Complete) {
            setOpen(false);
            if (props.onComplete) {
                props.onComplete();
            }
            const { taigaAuthState } = loginFlow;
            const taigaOnComplete = (_b = props.taigaLoginCodeRequestProps) === null || _b === void 0 ? void 0 : _b.onComplete;
            if (taigaAuthState && taigaOnComplete) {
                taigaOnComplete(taigaAuthState.userLogin, taigaAuthState.userResponse);
            }
            return;
        }
        else {
            return null;
        }
    };
    const login = useLoginFlow$1(props);
    const hideDialog = !isStandalone && login.loginStep === LoginStep.Complete;
    if (hideDialog && login.loginStep === LoginStep.Complete && props.onComplete) {
        if (!completeReached.current) {
            props.onComplete(login, (_b = userAuth.currentUserLogin) === null || _b === void 0 ? void 0 : _b.userType);
        }
        completeReached.current = true;
    }
    return !hideDialog ? (React.createElement(LoginDialog$1, { authTheme: authTheme, open: open || isStandalone, setOpen: setOpen, isStandalone: isStandalone, loading: login.loading, logo: (_d = (_c = props.authConfig) === null || _c === void 0 ? void 0 : _c.authTheme) === null || _d === void 0 ? void 0 : _d.logo, loginStep: login.loginStep, onCancel: props.onCancel }, dialogueForLoginStep(login))) : null;
};

var SingleColumnView;
(function (SingleColumnView) {
    SingleColumnView[SingleColumnView["Large"] = 0] = "Large";
    SingleColumnView[SingleColumnView["Medium"] = 1] = "Medium";
    SingleColumnView[SingleColumnView["Small"] = 2] = "Small";
    SingleColumnView[SingleColumnView["Compact"] = 3] = "Compact";
    SingleColumnView[SingleColumnView["Image"] = 4] = "Image";
    SingleColumnView[SingleColumnView["CompactImage"] = 5] = "CompactImage";
})(SingleColumnView || (SingleColumnView = {}));
const DefaultProviderValue = {
    channelKey: 'the-maven',
    roomKey: 'sodo',
    domain: 'https://mavencorp.io',
    singleColumnSettings: {
        defaultTab: 'Community',
        defaultSort: 'Newest',
        showDeck: true,
        showTopComment: true,
        cardView: SingleColumnView.Medium
    }
};
const ChannelContext = React.createContext(DefaultProviderValue);
const useMavenChannel = () => React.useContext(ChannelContext);

const getTargetUrl = (targetUrlProp) => {
    let origin;
    let queryTargetUrl;
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        queryTargetUrl = urlParams.get('targetUrl');
        origin = window.location.origin;
    }
    let target;
    if (isValidUrl(queryTargetUrl)) {
        target = queryTargetUrl;
    }
    else if (isValidUrl(targetUrlProp)) {
        target = targetUrlProp;
    }
    else if (isValidUrl(origin)) {
        target = origin;
    }
    return target;
};
const CoralTokenCookieName = 'mct';
const StandaloneLoginNoUserContext = ({ authConfig, channelKey, claimState, component, deviceType, isCoralFlow, isMeterFlow, location, siteId, step, taigaApiBase, targetUrl, userCookieConfig, onCompleteFunction }) => {
    const channelKeyId = channelKey || useMavenChannel().channelKey;
    const userAuth = useContext(UserContext);
    let currentUser = isCoralFlow ? userAuth.currentUserLogin : {};
    const usernameBehavior = isCoralFlow ? LoginUsernameCollectionBehavior.Required : LoginUsernameCollectionBehavior.None;
    const loginSource = isCoralFlow ? LoginCodeSource.CoralLogin : LoginCodeSource.StandaloneLogin;
    const { flags } = useTempestContext();
    const isStandalone = !isCoralFlow && !isMeterFlow;
    const [isOpenDialog, setOpenDialog] = useState(isStandalone);
    let viaLogin;
    let viaLoginComplete;
    const [cookies] = useCookies([CoralTokenCookieName]);
    const [isMeterLogin, setIsMeterLogin] = useState(isStandalone);
    if (typeof window !== 'undefined') {
        const { hash } = new URL(window.location.href);
        viaLogin = /viaLogin$/.test(hash);
        viaLoginComplete = /viaLoginComplete$/.test(hash);
    }
    let eventName = '';
    let urlHash = '';
    if (isCoralFlow) {
        eventName = 'phoenix:coral';
        urlHash = `#comments${viaLogin || viaLoginComplete ? '&viaLoginComplete' : ''}`;
    }
    else if (isMeterFlow) {
        eventName = 'phoenix:meter';
    }
    const noop = () => { };
    let onComplete = noop;
    let onCapture = noop;
    let onCancel = noop;
    let target = getTargetUrl(targetUrl);
    if (target && !onCompleteFunction) {
        target += urlHash;
        onComplete = () => {
            window.location.replace(target);
        };
    }
    if (isMeterFlow && !onCompleteFunction) {
        onCapture = () => {
            trackEmailCapture(channelKeyId);
        };
        onComplete = (login, loginType) => {
            var _a, _b, _c, _d;
            const completeEvent = new CustomEvent(eventName, {
                bubbles: true,
                detail: {
                    value: 'loginComplete',
                    login
                }
            });
            const rgis = (_b = (_a = login.taigaAuthState) === null || _a === void 0 ? void 0 : _a.userLogin) === null || _b === void 0 ? void 0 : _b.c3RGIS;
            let userId;
            if (rgis) {
                userId = (_d = (_c = rgis.replace(/"/g, '')) === null || _c === void 0 ? void 0 : _c.split('|')) === null || _d === void 0 ? void 0 : _d[0];
            }
            trackValidatedEmailCapture(authConfig.siteKeyword, loginType, userId);
            window.dispatchEvent(completeEvent);
        };
    }
    else if (onCompleteFunction) {
        onComplete = onCompleteFunction;
    }
    const taigaLoginCodeRequestProps = {
        taigaApiBase,
        siteId,
        claimState,
        deviceType,
        location,
        component: component || 'StandaloneLogin',
        onComplete,
        onLogin: (userLogin, userResponse) => {
            const loginStore = userCookieConfig ? new UserLoginStore(userCookieConfig) : undefined;
            if (loginStore) {
                loginStore.setUserLogin(userLogin);
            }
            userAuth.updateUserLogin(userLogin, userResponse);
        }
    };
    function handleActivationCustomEvents(event) {
        var _a;
        const eventValue = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value;
        switch (eventValue) {
            case 'login':
                setIsMeterLogin(true);
                setOpenDialog(true);
                break;
            case 'logout':
                setOpenDialog(false);
                userAuth.removeUserLogin();
                break;
        }
    }
    if (eventName) {
        onCancel = () => {
            setOpenDialog(false);
        };
        useEffect(() => {
            window === null || window === void 0 ? void 0 : window.addEventListener(eventName, handleActivationCustomEvents);
            return () => window === null || window === void 0 ? void 0 : window.removeEventListener(eventName, handleActivationCustomEvents);
        }, []);
        if (isCoralFlow) {
            if (!currentUser) {
                const store = new UserLoginStore(userCookieConfig);
                currentUser = {};
                if (store.getUserTokenCookie()) {
                    currentUser.userToken = store.getUserTokenCookie();
                }
                if (store.getRgisCookie()) {
                    currentUser.c3RGIS = store.getRgisCookie();
                }
                if (Object.keys(currentUser).length === 0) {
                    currentUser = undefined;
                }
            }
            useEffect(() => {
                if (currentUser && flags.includes('use-new-sign-in') && viaLogin && !cookies[CoralTokenCookieName]) {
                    setOpenDialog(true);
                }
            }, []);
        }
    }
    return (React.createElement(React.Fragment, null, authConfig !== null && (React.createElement(ConfigContextProvider, { authConfig: authConfig }, isOpenDialog ? (React.createElement(SyncLogin, { userLogin: currentUser, authConfig: authConfig, onLogin: (response) => {
            if (response) {
                const loginStore = userCookieConfig ? new UserLoginStore(userCookieConfig) : undefined;
                if (loginStore) {
                    loginStore.setUserLogin(response);
                }
                userAuth.updateUserLogin(response);
            }
        }, onCancel: onCancel, onComplete: onComplete, onCapture: onCapture, isStandalone: isStandalone, channelKey: authConfig.siteKeyword, label: "Continue with email", usernameBehavior: usernameBehavior, source: loginSource, doneLabel: "Continue", sendShortCode: true, taigaLoginCodeRequestProps: taigaLoginCodeRequestProps, showClassicLogin: step === LoginStep.ClassicLogin, viaLogin: viaLogin, viaLoginComplete: viaLoginComplete, isMeterLogin: isMeterLogin })) : (React.createElement(React.Fragment, null))))));
};
const StandaloneLogin = props => (React.createElement(UserContextProvider, null,
    React.createElement(StandaloneLoginNoUserContext, Object.assign({}, props))));

const useStyles$2 = makeStyles((theme) => {
    const getContentColor = (props) => {
        if (props.status === eStatus.Error)
            return theme.palette.error.main;
        if (props.status === eStatus.Success)
            return theme.palette.success.main;
        return undefined;
    };
    return {
        root: {
            backgroundColor: props => getContentColor(props),
            minWidth: 100,
            '&.Mui-disabled': {
                backgroundColor: props => (props.status !== eStatus.Default ? getContentColor(props) : undefined),
                color: props => (props.status !== eStatus.Default ? theme.palette.common.white : undefined)
            }
        },
        specialContent: {
            position: 'relative',
            top: 3
        },
        svg: {
            fontSize: '1.3rem'
        }
    };
});
const LoadingButton = (_a) => {
    var { status, children } = _a, buttonProps = __rest(_a, ["status", "children"]);
    const classes = useStyles$2({ status });
    return (React.createElement(Button, Object.assign({}, buttonProps, { className: clsx(buttonProps.className, {
            [classes.root]: status !== eStatus.Default
        }) }),
        React.createElement(Box, { className: classes.btnContent },
            status !== eStatus.Default && (React.createElement(Box, { className: classes.specialContent },
                status === eStatus.Submitting && React.createElement(CircularProgress, { color: "inherit", size: 20 }),
                status === eStatus.Error && React.createElement(Error$1, { className: classes.svg, color: "error" }),
                status === eStatus.Success && React.createElement(CheckCircle, { className: classes.svg, color: "inherit" }))),
            status === eStatus.Default && children)));
};
var LoadingButton$1 = LoadingButton;

var shipCountries = [
	{
		name: "United States",
		code: "US"
	},
	{
		name: "Canada",
		code: "CA"
	}
];

const useTTStyles = makeStyles(theme => {
    const inputAndSelect = Object.assign(Object.assign({}, theme.typography.body1), { padding: '18px 16px', '&::placeholder': {
            color: 'rgba(0, 0, 0, 0.5)',
            opacity: 1
        } });
    return {
        root: {
            backgroundColor: '#F9F9F9',
            borderRadius: 8,
            border: '1px solid transparent',
            '&.Mui-error': {
                border: '1px solid',
                borderColor: theme.palette.error.main
            },
            '&.Mui-focused': {
                backgroundColor: '#F9F9F9'
            }
        },
        input: inputAndSelect,
        select: inputAndSelect
    };
});
const TTSelect = props => {
    const _a = useTTStyles(), { root } = _a, classes = __rest(_a, ["root"]);
    return (React.createElement(Select, Object.assign({ native: true, type: "text", variant: "filled", disableUnderline: true }, props, { className: clsx(props.className, root), classes: { select: classes.select } })));
};
makeStyles(theme => ({
    caption: Object.assign(Object.assign({}, theme.typography.caption), { fontWeight: 500, color: 'rgba(0, 0, 0, 0.5)', paddingBottom: 24 }),
    captionSame: Object.assign(Object.assign({}, theme.typography.body1), { paddingBottom: 24 }),
    item: Object.assign(Object.assign({}, theme.typography.body1), { display: 'flex', justifyContent: 'space-between', paddingBottom: 16 }),
    divider: {
        backgroundColor: '#D8D8D8',
        margin: '0 0 16px 0'
    },
    boldItem: {
        fontWeight: 500
    }
}));

const useGiftRecipientFormStyles = makeStyles((theme) => ({
    box: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        maxWidth: theme.dimensions.maxReadableLength,
        textAlign: 'center',
        '& .MuiInputBase-root': {
            background: '#fff',
            '& input::placeholder, textarea::placeholder': {
                textTransform: 'uppercase'
            }
        },
        '& > div:not(:last-of-type), & > span.MuiTypography-root': {
            marginBottom: 20
        }
    },
    divider: {
        margin: '20px 0'
    },
    fieldsContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'space-between',
        '& > div': {
            flex: 1,
            '&:first-child': {
                marginRight: 10
            },
            '&:last-child': {
                marginLeft: 10
            }
        }
    },
    giftFormTitle: {
        color: '#505050',
        fontWeight: 400,
        textAlign: 'left'
    },
    postalCode: {
        width: 200
    }
}));
const GiftRecipientForm = ({ emailInputPlaceholderText, inputClass, isValid, recipientInfo, setGifterEmail, setRecipientInfo, setValid, showDeliveryAddress = false, showEmailInput, visible = false }) => {
    const initialGiftFormPristine = {
        deliveryAddress: true,
        email: true,
        firstName: true,
        gifterEmail: true,
        lastName: true
    };
    const initialAddressFieldsPristine = {
        city: true,
        postalCode: true,
        region: true,
        street1: true
    };
    const [isPristine, setPristine] = useState(initialGiftFormPristine);
    const [isAddressPristine, setAddressPristine] = useState(initialAddressFieldsPristine);
    const classes = useGiftRecipientFormStyles();
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [selectedShippingCountry, setSelectedShippingCountry] = React.useState('United States');
    const equalEmailsAlertText = 'Please enter an email that differs from your account email to send a gift';
    if (!visible || !setRecipientInfo || !recipientInfo) {
        return null;
    }
    const { customMessage, deliveryAddress = { city: '', postalCode: '', region: '', street1: '', street2: '' }, email, firstName, gifterEmail, lastName } = recipientInfo;
    const handleAddressFieldChange = (key, value) => {
        const field = Object.assign(Object.assign({}, deliveryAddress), { [key]: value });
        setAddressPristine(Object.assign(Object.assign({}, isAddressPristine), { [key]: false }));
        handleFieldChange('deliveryAddress', field);
    };
    const handleFieldChange = (key, value) => {
        const rI = Object.assign(Object.assign({}, recipientInfo), { [key]: value });
        setPristine(Object.assign(Object.assign({}, isPristine), { [key]: false }));
        setRecipientInfo(rI);
        setValid(isFormValid(rI));
    };
    const recipientEmailDifferentHelperText = (emailKey, emailValue) => {
        const emailsShouldBeDifferentFlag = areEmailsDifferent(emailKey, emailValue);
        if (isPristine[emailKey] || (isValidEmail(emailValue) && emailsShouldBeDifferentFlag)) {
            return '';
        }
        if (!emailValue) {
            return 'Required';
        }
        if (!emailsShouldBeDifferentFlag) {
            return equalEmailsAlertText;
        }
        return 'Please provide a valid email address';
    };
    const shouldShowError = (key, value) => !isPristine[key] && !value;
    const shouldShowAddressError = (key, value) => !isAddressPristine[key] && !value;
    function areEmailsDifferent(emailKey, emailValue) {
        return emailKey === 'email'
            ? emailValue !== gifterEmail
            : emailKey === 'gifterEmail'
                ? emailValue !== email
                : email !== gifterEmail;
    }
    function handleGifterEmailChange(value) {
        setGifterEmail(value);
        handleFieldChange('gifterEmail', value);
        setValid(isFormValid('gifterEmail', value));
    }
    function handleKeyDown(event) {
        if (event.key === 'Enter' && !areEmailsDifferent()) {
            setSnackbarOpen(true);
        }
    }
    function isFormValid(key, value) {
        if (key === 'gifterEmail') {
            return isValid && areEmailsDifferent(key, value);
        }
        const { email: emailValue, deliveryAddress: { city: cityValue, postalCode: postalCodeValue, region: stateValue, street1: street1Value } = {}, firstName: firstNameValue, lastName: lastNameValue } = key;
        return (!!firstNameValue &&
            !!lastNameValue &&
            isValidEmail(emailValue) &&
            (showEmailInput ? isValidEmail(gifterEmail) : true) &&
            areEmailsDifferent('email', emailValue) &&
            (showDeliveryAddress ? !!cityValue && !!postalCodeValue && !!stateValue && !!street1Value : true));
    }
    const renderDeliveryAddress = (React.createElement(React.Fragment, null,
        React.createElement(TextField, { autoComplete: "address-line1", className: inputClass, error: shouldShowAddressError('street1', deliveryAddress.street1), helperText: (shouldShowAddressError('street1', deliveryAddress.street1) && 'Required') || '', inputProps: { required: true }, onBlur: () => setAddressPristine(Object.assign(Object.assign({}, isAddressPristine), { street1: false })), onChange: e => handleAddressFieldChange('street1', e.target.value), placeholder: "STREET ADDRESS", type: "text", value: deliveryAddress.street1, variant: "outlined" }),
        React.createElement(TextField, { autoComplete: "address-line2", className: inputClass, onChange: e => handleAddressFieldChange('street2', e.target.value), placeholder: "APT, FLOOR, UNIT (OPTIONAL)", type: "text", value: deliveryAddress.street2, variant: "outlined" }),
        React.createElement(TextField, { autoComplete: "address-level2", className: inputClass, error: shouldShowAddressError('city', deliveryAddress.city), helperText: (shouldShowAddressError('city', deliveryAddress.city) && 'Required') || '', inputProps: { required: true }, onBlur: () => setAddressPristine(Object.assign(Object.assign({}, isAddressPristine), { city: false })), onChange: e => handleAddressFieldChange('city', e.target.value), placeholder: "CITY", type: "text", value: deliveryAddress.city, variant: "outlined" }),
        React.createElement(TTSelect, { autoComplete: "address-level1", name: "shipping_province", onChange: e => handleAddressFieldChange('region', e.target.value), placeholder: "STATE/PROVINCE", style: { color: (!deliveryAddress.region && '#949494') || undefined }, value: deliveryAddress.region, variant: "outlined" },
            React.createElement("option", { value: "" }, "STATE/PROVINCE"),
            (selectedShippingCountry === 'United States' ? usStates : canadianProvinces).map((state) => (React.createElement("option", { key: state.abbreviation, value: state.abbreviation }, state.abbreviation)))),
        React.createElement(TTSelect, { name: "shipping_country", placeholder: "COUNTRY", autoComplete: "address-level1", onChange: e => {
                handleAddressFieldChange('region', '');
                setSelectedShippingCountry(e.target.value);
            }, variant: "outlined" }, shipCountries.map((country) => (React.createElement("option", { key: country.name, value: country.name }, country.name)))),
        React.createElement(TextField, { autoComplete: "postal-code", className: inputClass, error: shouldShowAddressError('postalCode', deliveryAddress.postalCode), helperText: (shouldShowAddressError('postalCode', deliveryAddress.postalCode) && 'Required') || '', onBlur: () => setAddressPristine(Object.assign(Object.assign({}, isAddressPristine), { postalCode: false })), onChange: e => handleAddressFieldChange('postalCode', e.target.value), placeholder: "POSTAL CODE", style: { width: 200 }, type: "text", value: deliveryAddress.postalCode, variant: "outlined" })));
    const renderEmailInput = (showEmailInput && (React.createElement(React.Fragment, null,
        React.createElement(Divider, { className: classes.divider }),
        React.createElement("div", { className: classes.box },
            React.createElement(Typography, { className: classes.giftFormTitle, variant: "caption" }, "YOUR CONTACT INFORMATION"),
            React.createElement(TextField, { className: inputClass, error: !isPristine.gifterEmail && (!isValidEmail(gifterEmail) || !areEmailsDifferent()), fullWidth: true, helperText: recipientEmailDifferentHelperText('gifterEmail', gifterEmail), onBlur: () => setPristine(Object.assign(Object.assign({}, isPristine), { gifterEmail: false })), onChange: e => handleGifterEmailChange(e.target.value), onKeyDown: handleKeyDown, placeholder: emailInputPlaceholderText, type: "email", value: gifterEmail, variant: "outlined" }))))) ||
        null;
    return (React.createElement("div", null,
        renderEmailInput,
        React.createElement(Divider, { className: classes.divider }),
        React.createElement("div", { className: classes.box },
            React.createElement(Typography, { className: classes.giftFormTitle, variant: "caption" }, "GIFT RECIPIENT INFORMATION"),
            React.createElement("div", { className: classes.fieldsContainer },
                React.createElement(TextField, { className: inputClass, error: shouldShowError('firstName', firstName), helperText: (shouldShowError('firstName', firstName) && 'Required') || '', onBlur: () => setPristine(Object.assign(Object.assign({}, isPristine), { firstName: false })), onChange: e => handleFieldChange('firstName', e.target.value), placeholder: "First Name", type: "text", value: firstName, variant: "outlined" }),
                React.createElement(TextField, { className: inputClass, error: shouldShowError('lastName', lastName), helperText: (shouldShowError('lastName', lastName) && 'Required') || '', onBlur: () => setPristine(Object.assign(Object.assign({}, isPristine), { lastName: false })), onChange: e => handleFieldChange('lastName', e.target.value), placeholder: "Last Name", type: "text", value: lastName, variant: "outlined" })),
            React.createElement(TextField, { className: inputClass, error: !isPristine.email && (!isValidEmail(email) || !areEmailsDifferent()), fullWidth: true, helperText: recipientEmailDifferentHelperText('email', email), onBlur: () => setPristine(Object.assign(Object.assign({}, isPristine), { email: false })), onChange: e => handleFieldChange('email', e.target.value), onKeyDown: handleKeyDown, placeholder: "Email", type: "email", value: email, variant: "outlined" }),
            showDeliveryAddress && renderDeliveryAddress,
            React.createElement(TextField, { multiline: true, minRows: 4, variant: "outlined", type: "text", value: customMessage, onChange: e => handleFieldChange('customMessage', e.target.value), placeholder: "Custom Message (Optional)", className: inputClass, fullWidth: true })),
        React.createElement(Divider, { className: classes.divider }),
        React.createElement(Snackbar, { anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, autoHideDuration: 2000, open: snackbarOpen, onClick: () => setSnackbarOpen(false), onClose: () => setSnackbarOpen(false) },
            React.createElement(Alert, { severity: "error" }, equalEmailsAlertText))));
};
var GiftRecipientForm$1 = GiftRecipientForm;

const useStyles$1 = makeStyles((theme) => ({
    root: {
        margin: '0 auto',
        textAlign: 'center',
        maxWidth: theme.dimensions.maxReadableLength
    },
    terms: {
        margin: theme.spacing(1.5, 0, 3, 0),
        padding: theme.spacing(0, 1)
    },
    yourEmail: {
        fontSize: theme.typography.pxToRem(18),
        marginTop: theme.spacing(2)
    },
    changeBtn: {
        marginLeft: theme.spacing(2)
    }
}));
const EmailFormWithTerms = ({ buttonClass, inputClass, isGiftPage, email, placeholderText = 'Enter your email', recipientInfo = { email: '', firstName: '', gifterEmail: '', lastName: '' }, submitBtnText = 'Submit', termsContent, termsBelowButton = false, setEmail, setRecipientInfo, onSubmit, showDeliveryAddress, showEmailInput, setShowEmailInput, buttonStatus, changeEmailClicked, disableButton }) => {
    const [isRecipientFormValid, setRecipientFormValid] = useState(false);
    const classes = useStyles$1();
    const submitForm = (e) => {
        e.preventDefault();
        onSubmit(e);
    };
    const renderTerms = (React.createElement(Typography, { component: "div", variant: "caption", className: classes.terms }, termsContent));
    return (React.createElement(Box, { className: classes.root },
        React.createElement("form", { onSubmit: submitForm },
            React.createElement(GiftRecipientForm$1, { emailInputPlaceholderText: placeholderText, isValid: isRecipientFormValid, recipientInfo: recipientInfo, setGifterEmail: setEmail, setValid: setRecipientFormValid, setRecipientInfo: setRecipientInfo, showDeliveryAddress: !!showDeliveryAddress, showEmailInput: showEmailInput, visible: isGiftPage }),
            showEmailInput
                ? !isGiftPage && (React.createElement(TextField, { variant: "outlined", type: "email", value: email, onChange: e => setEmail(e.target.value), placeholder: placeholderText, className: inputClass, fullWidth: true }))
                : email && (React.createElement(Typography, { component: "div", variant: "caption", className: classes.yourEmail },
                    "Your email: ",
                    email,
                    React.createElement(Button, { className: classes.changeBtn, onClick: () => {
                            setEmail('');
                            setShowEmailInput(true);
                            changeEmailClicked();
                        } }, "Change"))),
            !termsBelowButton && renderTerms,
            React.createElement(LoadingButton$1, { status: buttonStatus, variant: "contained", size: "large", type: "submit", className: buttonStatus === eStatus.Default || buttonStatus === eStatus.Submitting ? buttonClass : undefined, disabled: disableButton ||
                    buttonStatus !== eStatus.Default ||
                    (showEmailInput && !isValidEmail(email)) ||
                    (isGiftPage && !isRecipientFormValid) }, submitBtnText)),
        termsBelowButton && renderTerms));
};
var EmailFormWithTerms$1 = EmailFormWithTerms;

const useStyles = makeStyles$1((theme) => createStyles({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    title: {
        flexGrow: 1
    },
    userAvatar: {
        '& img': {
            borderRadius: 8
        }
    },
    userTotalpost: {
        color: theme.palette.grey[500],
        marginLeft: theme.spacing(2),
        fontSize: theme.typography.pxToRem(14),
        display: 'grid'
    }
}));
function LoginButton({ authConfig, taigaApiBase, siteId, claimState, deviceType, location, component, buttonClass, loginEvent }) {
    const classes = useStyles();
    const [isOpenDialog, setOpenDialog] = useState(false);
    const userContext = useContext(UserContext);
    const taigaLoginCodeRequestProps = {
        taigaApiBase,
        siteId,
        claimState,
        deviceType,
        location,
        component,
        onLogin: (userLogin, userResponse) => {
            userContext.updateUserLogin(userLogin, userResponse);
            if (loginEvent) {
                window.dispatchEvent(new window.CustomEvent(loginEvent, { bubbles: true }));
            }
        }
    };
    const onComplete = (loginFlow, userType) => {
        const completeEvent = new CustomEvent('phoenix:meter', {
            bubbles: true,
            detail: {
                value: 'loginComplete',
                login: loginFlow
            }
        });
        window.dispatchEvent(completeEvent);
    };
    function onLogin(response) {
        if (response) {
            userContext.updateUserLogin(response);
        }
    }
    const handleLoginClick = (authConfig === null || authConfig === void 0 ? void 0 : authConfig.onCustomLogin) || (() => setOpenDialog(true));
    const currentUser = userContext.currentUserLogin;
    return (React.createElement("div", { className: classes.root },
        buttonClass ? (React.createElement("button", { className: buttonClass, onClick: handleLoginClick }, "Sign In")) : (''),
        ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.userToken) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.c3RGIS)) && !buttonClass ? (React.createElement(ListItem, null,
            React.createElement(Link, { href: authConfig === null || authConfig === void 0 ? void 0 : authConfig.accountProfile },
                React.createElement(ProfileIcon, null)))) : isOpenDialog ? (React.createElement(SyncLogin, { userLogin: currentUser, authConfig: authConfig, onLogin: onLogin, onComplete: onComplete, onCancel: () => setOpenDialog(false), channelKey: authConfig === null || authConfig === void 0 ? void 0 : authConfig.siteKeyword, label: "Continue with Email", usernameBehavior: LoginUsernameCollectionBehavior.None, sendShortCode: true, taigaLoginCodeRequestProps: taigaLoginCodeRequestProps })) : buttonClass ? ('') : (React.createElement(ListItem, null,
            React.createElement(LoginBtn, { size: "large", variant: "outlined", onClick: handleLoginClick }, "Sign In")))));
}
function UniversalSideMenuUserAuth({ authConfig, taigaApiBase, siteId, claimState, deviceType, location, component, buttonClass, loginEvent }) {
    return (React.createElement(UserContextProvider, null,
        React.createElement(LoginButton, { authConfig: authConfig, taigaApiBase: taigaApiBase, siteId: siteId, claimState: claimState, deviceType: deviceType, location: location, component: component, buttonClass: buttonClass, loginEvent: loginEvent })));
}
const LoginBtn = withStyles((theme) => ({
    root: {
        color: 'currentColor',
        borderColor: 'currentColor',
        borderWidth: 1.5,
        textTransform: 'uppercase',
        letterSpacing: 'normal',
        '&:hover': {
            backgroundColor: 'inherit'
        }
    }
}))(Button);

export { EmailFormWithTerms$1 as EmailFormWithTerms, PaletteType, SodoThemeProvider, StandaloneLogin, TempestContextProvider, UniversalSideMenuUserAuth, sodoDarkTheme, sodoTheme, useTempestContext };
